import { useEffect, useId, useMemo, useRef, useState } from "react";
import logo from "./assets/logo.svg";
import "./home_page.css";
import "./portfolio_dashboard.css";
import {
  SIDEBAR_NAV,
  action_badge_class,
  action_badge_label,
  count_by_filter,
  is_profit_position,
  build_dashboard_risk_chips,
  compute_dashboard_risk_meter_score,
  risk_meter_band_label,
  risk_meter_band_key,
  risk_meter_summary_text,
  buy_more_stocks,
  filter_stocks,
  fmt_inr,
  fmt_inr_full,
  fmt_num,
  fmt_pct,
  format_portfolio_summary,
  get_nav_item_count,
  get_nav_page_config,
  build_portfolio_period_vs_nifty,
  get_period_vs_nifty_series,
  get_stock_exchange_codes,
  pct_class,
  plan_loss_amount,
  select_top_action_stocks,
  parse_outlook_narrative,
  split_impact_summary_parts,
  split_narrative_highlight_parts,
  split_narrative_parenthetical,
  nav_id_for_stock,
  nav_label_for_stock,
  stock_filter_key,
  stock_matches_search,
  stock_visible_in_filter,
  filter_industry_peers_outside_portfolio,
} from "./dashboard_utils";

function SidebarBrand() {
  return (
    <img
      src={logo}
      alt="InvestVidhi — Powered by SIHO Research"
      className="sidebar_premium__logo"
    />
  );
}

function SidebarIcon({ name }) {
  const stroke = 1.55;
  const icons = {
    dashboard: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth={stroke} />
        <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth={stroke} />
        <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth={stroke} />
        <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth={stroke} />
      </svg>
    ),
    portfolio: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M8 7h8a2 2 0 012 2v9a2 2 0 01-2 2H8a2 2 0 01-2-2V9a2 2 0 012-2z"
          stroke="currentColor"
          strokeWidth={stroke}
        />
        <path d="M9 7V6a3 3 0 016 0v1" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" />
      </svg>
    ),
    buy: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M4 16l5-6 4 4 6-8"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    avg_down: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 4.5v12.5M8 13.5l4 4.5 4-4.5"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    avg_up: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 19.5V7M8 10.5l4-4.5 4 4.5"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    cut_loss: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="6" cy="7" r="2.5" stroke="currentColor" strokeWidth={stroke} />
        <circle cx="18" cy="17" r="2.5" stroke="currentColor" strokeWidth={stroke} />
        <path d="M8 8.5l8 7M16 6.5L8 15.5" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" />
      </svg>
    ),
    exit: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M8.5 7.5L4 12l4.5 4.5M4 12h14"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    trim: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 8h11M5 12h14M5 16h9" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" />
        <circle cx="18" cy="8" r="1.25" fill="currentColor" />
        <circle cx="16" cy="16" r="1.25" fill="currentColor" />
      </svg>
    ),
    profit: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M4.5 15.5l4.5-5.5 3.5 3.5L19.5 6.5"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M15 6.5h4.5V11" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" />
      </svg>
    ),
    hold: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 20.5s-6.5-4-6.5-9a4.5 4.5 0 019 0c0 5-6.5 9-6.5 9z"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinejoin="round"
        />
      </svg>
    ),
    book_profit: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 3v18M8.5 7.5h5a2.5 2.5 0 010 5h-5a2.5 2.5 0 000 5h7"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    execution: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M4 12h4l2-5 4 10 2-5h4"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    logout: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    reports: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M4 8h16v11a1 1 0 01-1 1H5a1 1 0 01-1-1V8z"
          stroke="currentColor"
          strokeWidth={stroke}
        />
        <path d="M8 5h8l2 3H6l2-3z" stroke="currentColor" strokeWidth={stroke} strokeLinejoin="round" />
      </svg>
    ),
  };
  return (
    <span className="sidebar_nav__icon_wrap">
      <span className="sidebar_nav__icon">{icons[name] || icons.portfolio}</span>
    </span>
  );
}

const ACTION_WISE_ROWS = [
  { key: "average_down", label: "Average Down" },
  { key: "average_up", label: "Buy More" },
  { key: "hold", label: "Hold" },
  { key: "cut_loss", label: "Cut Loss" },
  { key: "exit", label: "Exit" },
  { key: "profit_booking", label: "Profit Booking" },
];

function OverviewKv({ label, children, value_class = "", row_class = "" }) {
  return (
    <div className={`portfolio_overview__kv${row_class ? ` ${row_class}` : ""}`}>
      <span className="portfolio_overview__kv_label">{label}</span>
      <span className={`portfolio_overview__kv_val${value_class ? ` ${value_class}` : ""}`}>
        {children}
      </span>
    </div>
  );
}

function InsightMetrics({ children }) {
  return <div className="portfolio_overview__insight_metrics">{children}</div>;
}

function ActionWiseMetric({ label, value, tone = "" }) {
  if (value == null) return null;

  return (
    <div className="portfolio_overview__action_metric">
      <span className="portfolio_overview__action_metric_label">{label}</span>
      <span className={`portfolio_overview__action_metric_val${tone ? ` is_${tone}` : ""}`}>{value}</span>
    </div>
  );
}

const NET_IMPACT_ROWS = [
  { key: "net_proceeds", label: "Net proceeds", field: "net_proceeds" },
  { key: "net_profit_booked", label: "Profit booked", field: "net_profit_booked", tone: "pos" },
  { key: "net_loss_booked", label: "Loss booked", field: "net_loss_booked", tone: "neg" },
  { key: "net_avg_up_capital", label: "Avg-up capital", field: "net_avg_up_capital" },
  { key: "portfolio_new_invested", label: "New invested", field: "portfolio_new_invested", tone: "theme" },
  { key: "portfolio_new_market_value", label: "New market value", field: "portfolio_new_market_value" },
];

function NetImpactSummaryPanel({ action_summary }) {
  if (!action_summary || !Object.keys(action_summary).length) return null;

  return (
    <div className="portfolio_dashboard__panel portfolio_overview__net_impact_panel">
      <h4 className="portfolio_overview__net_impact_title">Net impact (all actions)</h4>
      <div className="portfolio_overview__net_impact_grid">
        {NET_IMPACT_ROWS.map(({ key, label, field, tone }) => {
          const raw = action_summary[field];
          if (raw == null) return null;

          return (
            <div key={key} className="portfolio_overview__net_impact_item">
              <span className="portfolio_overview__net_impact_label">{label}</span>
              <span
                className={`portfolio_overview__net_impact_val${tone ? ` is_${tone}` : ""}`}
              >
                {fmt_inr(raw)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function resolve_buy_more_wise_block(action_wise, stocks, action_summary) {
  const aws_up = action_wise?.average_up || {};
  const buy_more_list = buy_more_stocks(stocks);
  const totals = accumulate_section_totals(buy_more_list, action_wise, action_summary);
  const stock_count =
    buy_more_list.length > 0 ? buy_more_list.length : aws_up.stock_count ?? 0;

  return {
    ...aws_up,
    stock_count,
    capital_required: totals.capital_required ?? aws_up.capital_required,
  };
}

function resolve_hold_wise_block(stocks, filter_counts) {
  const hold_count = filter_counts?.hold ?? filter_stocks(stocks, "hold").length;
  return { stock_count: hold_count };
}

function ActionWiseSummaryPanel({ action_wise, stocks = [], action_summary = {}, filter_counts = {} }) {
  if (!Object.keys(action_wise).length) return null;

  return (
    <div className="portfolio_dashboard__panel portfolio_overview__action_panel">
      <h4 className="portfolio_overview__action_panel_title">Action-wise summary</h4>
      <div className="portfolio_overview__action_grid">
        {ACTION_WISE_ROWS.map(({ key, label }) => {
          let block = action_wise[key];
          if (key === "average_up") {
            block = resolve_buy_more_wise_block(action_wise, stocks, action_summary);
          } else if (key === "hold") {
            block = resolve_hold_wise_block(stocks, filter_counts);
            if ((block.stock_count ?? 0) <= 0) return null;
          }
          if (!block) return null;

          const stock_count = block.stock_count ?? 0;
          if (key === "average_up") {
            return (
              <div key={key} className="portfolio_overview__action_card">
                <div className="portfolio_overview__action_card_title">{label}</div>
                <div className="portfolio_overview__action_card_count">
                  <span
                    className={`portfolio_overview__action_card_count_num${
                      stock_count > 0 ? " is_active" : ""
                    }`}
                  >
                    {stock_count}
                  </span>
                  <span className="portfolio_overview__action_card_count_lbl">stocks</span>
                </div>
              </div>
            );
          }

          const has_metrics =
            (block.capital_required != null && block.capital_required > 0) ||
            block.net_proceeds != null ||
            block.net_loss != null ||
            block.profit_booked != null ||
            block.net_loss_saved != null;

          if (key === "hold") {
            return (
              <div key={key} className="portfolio_overview__action_card">
                <div className="portfolio_overview__action_card_title">{label}</div>
                <div className="portfolio_overview__action_card_count">
                  <span
                    className={`portfolio_overview__action_card_count_num${
                      stock_count > 0 ? " is_active" : ""
                    }`}
                  >
                    {stock_count}
                  </span>
                  <span className="portfolio_overview__action_card_count_lbl">stocks</span>
                </div>
                <p className="portfolio_overview__action_card_hint">
                  No deployment or sale is scheduled here.
                </p>
              </div>
            );
          }

          return (
            <div key={key} className="portfolio_overview__action_card">
              <div className="portfolio_overview__action_card_title">{label}</div>
              <div className="portfolio_overview__action_card_count">
                <span
                  className={`portfolio_overview__action_card_count_num${
                    stock_count > 0 ? " is_active" : ""
                  }`}
                >
                  {stock_count}
                </span>
                <span className="portfolio_overview__action_card_count_lbl">stocks</span>
              </div>
              <div
                className={`portfolio_overview__action_card_metrics${
                  has_metrics ? "" : " is_empty"
                }`}
              >
              {has_metrics ? (
                <>
                  {block.capital_required != null && block.capital_required > 0 && (
                    <ActionWiseMetric
                      label="Capital"
                      value={fmt_inr(block.capital_required)}
                      tone="theme"
                    />
                  )}
                  {block.net_proceeds != null && (
                    <ActionWiseMetric label="Proceeds" value={fmt_inr(block.net_proceeds)} />
                  )}
                  {block.net_loss != null && (
                    <ActionWiseMetric label="Loss" value={fmt_inr(block.net_loss)} tone="neg" />
                  )}
                  {block.profit_booked != null && (
                    <ActionWiseMetric label="Profit" value={fmt_inr(block.profit_booked)} tone="pos" />
                  )}
                  {block.net_loss_saved != null && (
                    <ActionWiseMetric label="Loss saved" value={fmt_inr(block.net_loss_saved)} />
                  )}
                </>
              ) : (
                <span className="portfolio_overview__action_card_empty">No activity</span>
              )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function breadth_number_highlight_class(before, after) {
  const ctx = `${before}${after}`.toLowerCase();
  if (/holding up|in profit/.test(ctx)) {
    return "portfolio_overview__breadth_hl_pos";
  }
  if (/in loss|nifty is down|down [\d.]+%|down more/.test(ctx)) {
    return "portfolio_overview__breadth_hl_neg";
  }
  if (/20%|52-week|52w/.test(ctx)) {
    return "portfolio_overview__breadth_hl_warn";
  }
  return "portfolio_overview__breadth_hl_num";
}

function split_breadth_sentences(text) {
  return format_portfolio_summary(text)
    .split(/(?<=[.!?])\s+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

function render_breadth_highlighted_sentence(sentence) {
  const re = /\d+(?:\.\d+)?%?/g;
  const parts = [];
  let last = 0;
  let match;
  let key = 0;

  while ((match = re.exec(sentence)) !== null) {
    const start = match.index;
    const end = start + match[0].length;

    if (start > last) {
      parts.push(sentence.slice(last, start));
    }

    const hl_class = breadth_number_highlight_class(
      sentence.slice(Math.max(0, start - 45), start),
      sentence.slice(end, Math.min(sentence.length, end + 45))
    );

    parts.push(
      <strong key={`hl-${key++}`} className={hl_class}>
        {match[0]}
      </strong>
    );
    last = end;
  }

  if (last < sentence.length) {
    parts.push(sentence.slice(last));
  }

  return parts;
}

function BreadthDetailSummary({ text }) {
  const [is_open, set_is_open] = useState(false);
  const sentences = split_breadth_sentences(text);
  if (!sentences.length) return null;

  return (
    <div className={`portfolio_overview__breadth_dropdown${is_open ? " is_open" : ""}`}>
      <button
        type="button"
        className="portfolio_overview__breadth_dropdown_toggle"
        onClick={() => set_is_open((open) => !open)}
        aria-expanded={is_open}
        aria-controls="breadth-summary-panel"
      >
        <span className="portfolio_overview__breadth_dropdown_icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M12 16v-4m0-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </span>
        <span className="portfolio_overview__breadth_dropdown_label">Summary</span>
        <span className="portfolio_overview__breadth_dropdown_chevron" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>
      {is_open && (
        <div id="breadth-summary-panel" className="portfolio_overview__breadth_dropdown_panel">
          <ul className="portfolio_overview__breadth_summary_list">
            {sentences.map((sentence, i) => (
              <li key={`breadth-line-${i}`}>{render_breadth_highlighted_sentence(sentence)}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

const SECTOR_CHART_COLORS = [
  "#3b82f6",
  "#22c55e",
  "#f97316",
  "#eab308",
  "#8b5cf6",
  "#06b6d4",
  "#ec4899",
  "#64748b",
];

function sector_donut_slice_path(cx, cy, r_outer, r_inner, start_angle, end_angle) {
  const large = end_angle - start_angle > Math.PI ? 1 : 0;
  const x1o = cx + r_outer * Math.cos(start_angle);
  const y1o = cy + r_outer * Math.sin(start_angle);
  const x2o = cx + r_outer * Math.cos(end_angle);
  const y2o = cy + r_outer * Math.sin(end_angle);
  const x2i = cx + r_inner * Math.cos(end_angle);
  const y2i = cy + r_inner * Math.sin(end_angle);
  const x1i = cx + r_inner * Math.cos(start_angle);
  const y1i = cy + r_inner * Math.sin(start_angle);
  return `M ${x1o} ${y1o} A ${r_outer} ${r_outer} 0 ${large} 1 ${x2o} ${y2o} L ${x2i} ${y2i} A ${r_inner} ${r_inner} 0 ${large} 0 ${x1i} ${y1i} Z`;
}

function SectorPieChart({ sectors }) {
  const items = (sectors || [])
    .map((s) => ({
      name: format_portfolio_summary(s.name || ""),
      weight: parseFloat(s.weight_pct) || 0,
    }))
    .filter((s) => s.weight > 0);

  if (!items.length) return null;

  const total = items.reduce((sum, s) => sum + s.weight, 0) || 1;
  const cx = 80;
  const cy = 80;
  const r_outer = 62;
  const r_inner = 40;
  const gap = items.length > 1 ? 0.028 : 0;
  let angle = -Math.PI / 2;

  const slices = items.map((item, i) => {
    const slice = (item.weight / total) * 2 * Math.PI;
    const start_angle = angle + gap / 2;
    const end_angle = angle + slice - gap / 2;
    angle += slice;
    const color = SECTOR_CHART_COLORS[i % SECTOR_CHART_COLORS.length];
    const path = sector_donut_slice_path(cx, cy, r_outer, r_inner, start_angle, end_angle);

    return <path key={`${item.name}-${i}`} d={path} fill={color} />;
  });

  return (
    <div className="portfolio_overview__sector_chart portfolio_overview__sector_chart--donut">
      <div className="portfolio_overview__sector_donut_wrap">
        <svg viewBox="0 0 160 160" className="portfolio_overview__sector_donut_svg" aria-hidden="true">
          {slices}
          <circle cx={cx} cy={cy} r={r_inner - 1} className="portfolio_overview__sector_donut_hole" />
          <text
            x={cx}
            y={cy}
            className="portfolio_overview__sector_donut_center"
            textAnchor="middle"
            dominantBaseline="middle"
          >
            100%
          </text>
        </svg>
      </div>
      <ul className="portfolio_overview__sector_legend">
        {items.map((item, i) => (
          <li key={`${item.name}-legend-${i}`}>
            <span
              className="portfolio_overview__sector_legend_dot"
              style={{ background: SECTOR_CHART_COLORS[i % SECTOR_CHART_COLORS.length] }}
            />
            <span className="portfolio_overview__sector_legend_name" title={item.name}>
              {item.name}
            </span>
            <span className="portfolio_overview__sector_legend_pct">{item.weight.toFixed(1)}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function portfolio_score_to_100(action_score) {
  const n = parseFloat(action_score);
  if (Number.isNaN(n)) return null;
  return Math.round((n / 5) * 100);
}

function portfolio_score_label(score_100) {
  if (score_100 == null) return "—";
  if (score_100 >= 80) return "Good";
  if (score_100 >= 60) return "Fair";
  return "Needs attention";
}

function portfolio_score_label_tone(label) {
  if (label === "Good") return "is_good";
  if (label === "Fair") return "is_fair";
  return "is_attention";
}

/** Donut / tag color: 45+ on /100 scale = green, else orange. */
function portfolio_score_visual_tone(score_100) {
  if (score_100 == null) return "is_attention";
  return score_100 >= 45 ? "is_good" : "is_fair";
}

function risk_short_label(risk_meter_score) {
  return risk_meter_band_label(risk_meter_score);
}

function dashboard_action_display(stock) {
  const action = (stock?.action || "").trim();
  const a = action.toLowerCase();
  const ret = parseFloat(stock?.holding?.return_pct);

  if (a.includes("average up")) return { label: "AVERAGE UP", tone: "avg_up" };
  if (a.includes("average down")) return { label: "AVERAGE DOWN", tone: "avg_down" };
  if (a === "hold") return { label: "HOLD", tone: "hold" };
  if (a === "exit") {
    if (!Number.isNaN(ret) && ret > 0) return { label: "BOOK PROFIT", tone: "profit" };
    return { label: "EXIT", tone: "exit" };
  }
  if (a.includes("accumulate") || a.includes("buy")) return { label: "BUY MORE", tone: "buy" };
  if (a === "reduce") {
    if (!Number.isNaN(ret) && ret > 0) return { label: "BOOK PROFIT", tone: "profit" };
    return { label: "CUT LOSS", tone: "cut_loss" };
  }
  return { label: action.toUpperCase() || "—", tone: "muted" };
}

function avg_stock_metric_100(stocks, key) {
  const vals = (stocks || [])
    .map((s) => parseFloat(s.scores?.[key]))
    .filter((v) => !Number.isNaN(v));
  if (!vals.length) return null;
  return Math.round((vals.reduce((a, b) => a + b, 0) / vals.length / 5) * 100);
}

function diversification_score_100(conc, sectors) {
  const top = parseFloat(sectors?.[0]?.weight_pct);
  if (!Number.isNaN(top)) return Math.round(Math.max(0, Math.min(100, 100 - top * 1.8)));
  const n = conc?.distinct_sectors;
  if (n != null) return Math.round(Math.min(100, n * 11));
  return null;
}

function format_dashboard_updated() {
  const now = new Date();
  const time = now.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", hour12: true });
  return `Today, ${time}`;
}

function DashboardSummaryKpiIcon({ variant }) {
  const icons = {
    value: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M8 8h8a3 3 0 010 6H9a2 2 0 000 4h7M12 5v2M12 17v2"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    score: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 2l2.2 6.8H21l-5.5 4 2.1 6.8L12 16.8 6.4 19.6l2.1-6.8L3 8.8h6.8L12 2z"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
      </svg>
    ),
    returns: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M4 16l5-6 4 4 7-9"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    invested: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.75" />
        <path d="M8 7V6a4 4 0 018 0v1" stroke="currentColor" strokeWidth="1.75" />
        <path d="M12 11v4M10 13h4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      </svg>
    ),
  };

  return (
    <span className={`portfolio_dash_summary_card__icon is_${variant}`} aria-hidden="true">
      {icons[variant]}
    </span>
  );
}

function DashboardSummaryKpiHead({ variant, label }) {
  return (
    <div className="portfolio_dash_summary_card__head">
      <DashboardSummaryKpiIcon variant={variant} />
      <span className="portfolio_dash_summary_card__lbl">{label}</span>
    </div>
  );
}

function ScoreDonutChart({ score, label }) {
  const value = score != null ? Math.max(0, Math.min(100, score)) : null;
  const cx = 90;
  const cy = 90;
  const r = 58;
  const stroke = 20;
  const c = 2 * Math.PI * r;
  const offset = value != null ? c * (1 - value / 100) : c;
  const tone = portfolio_score_visual_tone(value);

  return (
    <div className="portfolio_dash_donut_wrap">
      <div className="portfolio_dash_donut">
        <svg viewBox="0 0 180 180" className="portfolio_dash_donut__svg" aria-hidden="true">
          <circle
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            className="portfolio_dash_donut__track"
            strokeWidth={stroke}
          />
          <circle
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            className={`portfolio_dash_donut__fill${tone ? ` ${tone}` : ""}`}
            strokeWidth={stroke}
            strokeDasharray={c}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform={`rotate(-90 ${cx} ${cy})`}
          />
        </svg>
        <div className="portfolio_dash_donut__center">
          <strong className="portfolio_dash_donut__val">
            {value != null ? (
              <>
                {value}
                <span className="portfolio_dash_donut__of">/100</span>
              </>
            ) : (
              "—"
            )}
          </strong>
        </div>
      </div>
      {label && label !== "—" && (
        <p className={`portfolio_dash_donut__caption ${tone}`}>{label}</p>
      )}
    </div>
  );
}

function ScoreMetricBar({ label, value }) {
  const pct = value != null ? Math.max(0, Math.min(100, value)) : 0;
  return (
    <div className="portfolio_dash_score_metric">
      <div className="portfolio_dash_score_metric__head">
        <span>{label}</span>
        <strong>{value != null ? `${Math.round(value)}/100` : "—"}</strong>
      </div>
      <div className="portfolio_dash_score_metric__track">
        <span className="portfolio_dash_score_metric__fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

function meter_gauge_polar(cx, cy, r, deg) {
  const rad = (deg * Math.PI) / 180;
  return { x: cx + r * Math.cos(rad), y: cy - r * Math.sin(rad) };
}

function meter_gauge_arc(cx, cy, r, start_deg, end_deg) {
  const start = meter_gauge_polar(cx, cy, r, start_deg);
  const end = meter_gauge_polar(cx, cy, r, end_deg);
  const large = Math.abs(end_deg - start_deg) > 180 ? 1 : 0;
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${large} 1 ${end.x} ${end.y}`;
}

const METER_GAUGE_SEGMENT_COLORS = [
  "#dc2626",
  "#f97316",
  "#eab308",
  "#84cc16",
  "#16a34a",
];

/** Risk gauge: low (green) → moderate → high (red). */
const METER_GAUGE_RISK_COLORS = ["#16a34a", "#f59e0b", "#dc2626"];

const METER_SCALE_TICKS = {
  score: [
    { value: 1, label: "1" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 75, label: "75" },
    { value: 100, label: "100" },
  ],
  risk: [
    { value: 0, label: "0" },
    { value: 40, label: "40" },
    { value: 70, label: "70" },
    { value: 100, label: "100" },
  ],
  percent: [
    { value: 0, label: "0%" },
    { value: 25, label: "25%" },
    { value: 50, label: "50%" },
    { value: 75, label: "75%" },
    { value: 100, label: "100%" },
  ],
};

function meter_value_to_angle(value) {
  const v = Math.max(0, Math.min(100, parseFloat(value)));
  if (Number.isNaN(v)) return null;
  return 180 - (v / 100) * 180;
}

function DashboardSpeedometerMeter({
  pct,
  display,
  caption,
  value_hint = null,
  scale_low_label = "0",
  scale_high_label = "100",
  meter_scale = "score",
  color_mode = "default",
  compact = false,
}) {
  const meter_value = pct != null ? Math.max(0, Math.min(100, parseFloat(pct))) : null;
  const cx = 100;
  const cy = 92;
  const r = 64;
  const is_risk_gauge = color_mode === "risk";
  const segment_colors = is_risk_gauge ? METER_GAUGE_RISK_COLORS : METER_GAUGE_SEGMENT_COLORS;
  const seg_span = is_risk_gauge ? 60 : 180 / segment_colors.length;
  const ticks = METER_SCALE_TICKS[meter_scale] || METER_SCALE_TICKS.score;
  let needle_tip = null;

  if (meter_value != null && !Number.isNaN(meter_value)) {
    const angle = meter_value_to_angle(meter_value);
    if (angle != null) needle_tip = meter_gauge_polar(cx, cy, r * 0.84, angle);
  }

  const label_y = cy + 16;
  const scale_class = is_risk_gauge
    ? " is_risk_scale"
    : meter_scale === "percent"
      ? " is_percent_scale"
      : " is_score_scale";

  return (
    <div
      className={`portfolio_dash_speedometer${compact ? " is_compact" : ""}${scale_class}${
        is_risk_gauge ? " is_risk_gauge" : ""
      }`}
      aria-label={caption ? `${caption} ${display ?? ""}` : undefined}
    >
      {caption && <span className="portfolio_dash_speedometer__title">{caption}</span>}
      <svg viewBox="0 0 200 118" className="portfolio_dash_speedometer__svg" aria-hidden="true">
        {segment_colors.map((color, i) => {
          const start = 180 - i * seg_span;
          const end = 180 - (i + 1) * seg_span;
          return (
            <path
              key={`${color_mode}-${i}-${color}`}
              d={meter_gauge_arc(cx, cy, r, start, end)}
              fill="none"
              stroke={color}
              strokeWidth="13"
              strokeLinecap="butt"
            />
          );
        })}
        {ticks.map((tick) => {
          const angle = meter_value_to_angle(tick.value);
          if (angle == null) return null;
          const pt = meter_gauge_polar(cx, cy, r + 16, angle);
          return (
            <text
              key={`${meter_scale}-${tick.value}`}
              x={pt.x}
              y={pt.y}
              className="portfolio_dash_speedometer__tick"
              textAnchor="middle"
              dominantBaseline="middle"
            >
              {tick.label}
            </text>
          );
        })}
        <text
          x={cx - r}
          y={label_y}
          className="portfolio_dash_speedometer__extreme is_low"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {scale_low_label}
        </text>
        <text
          x={cx + r}
          y={label_y}
          className="portfolio_dash_speedometer__extreme is_high"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {scale_high_label}
        </text>
        <circle cx={cx} cy={cy} r="5" className="portfolio_dash_speedometer__hub" />
        {needle_tip && (
          <line
            x1={cx}
            y1={cy}
            x2={needle_tip.x}
            y2={needle_tip.y}
            className="portfolio_dash_speedometer__needle"
          />
        )}
      </svg>
      <strong className="portfolio_dash_speedometer__val">{display ?? "—"}</strong>
      {value_hint && <p className="portfolio_dash_speedometer__hint">{value_hint}</p>}
    </div>
  );
}

function PortfolioMeterPanel({
  title,
  variant,
  badge_label,
  summary_text,
  chips,
  pct,
  display,
  value_hint = null,
  meter_scale = "score",
  color_mode = "default",
  scale_low_label = "0",
  scale_high_label = "100",
  badge_tone = null,
}) {
  const badge_mod =
    variant === "breadth"
      ? " is_breadth"
      : badge_tone
        ? ` is_risk_${badge_tone}`
        : "";

  return (
    <div className={`portfolio_dash_panel portfolio_dash_panel--meter is_${variant}`}>
      <h4 className="portfolio_dash_panel__title">{title}</h4>
      <div className="portfolio_dash_panel--meter_body portfolio_dash_risk_split">
        <DashboardSpeedometerMeter
          pct={pct}
          display={display}
          value_hint={value_hint}
          meter_scale={meter_scale}
          color_mode={color_mode}
          scale_low_label={scale_low_label}
          scale_high_label={scale_high_label}
        />
        <div className="portfolio_dash_risk_side">
          {badge_label && badge_label !== "—" && (
            <span className={`portfolio_dash_risk_badge${badge_mod}`}>
              {badge_label}
            </span>
          )}
          {summary_text && (
            <p className="portfolio_dash_risk_blurb" title={format_portfolio_summary(summary_text)}>
              {format_portfolio_summary(summary_text)}
            </p>
          )}
          {chips?.length > 0 && (
            <div className="portfolio_dash_risk_chips">
              {chips.map((chip) => (
                <span
                  key={chip.label}
                  className={`portfolio_dash_risk_chip${chip.tone ? ` is_${chip.tone}` : ""}`}
                >
                  {chip.label}{" "}
                  <strong>{chip.value}</strong>
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const DASHBOARD_ACTION_PILLS = [
  { key: "accumulate", label: "Buy More", count_key: "accumulate", tone: "avg_up" },
  { key: "average_down", label: "Average Down", count_key: "average_down", tone: "avg_down" },
  { key: "hold", label: "Hold", count_key: "hold", tone: "hold" },
  { key: "profit_booking", label: "Profit Book", count_key: "profit_booking", tone: "profit" },
  { key: "cut_loss", label: "Cut Loss", count_key: "cut_loss", tone: "cut_loss" },
  { key: "exit", label: "Exit", count_key: "exit", tone: "exit" },
];

function DashboardActionPills({ filter_counts, action_wise, stocks = [] }) {
  return (
    <div className="portfolio_dash_action_pills">
      <h4 className="portfolio_dash_section_title">Stock Action Summary</h4>
      <div className="portfolio_dash_action_pills__row">
        {DASHBOARD_ACTION_PILLS.map(({ key, label, count_key, tone }) => {
          const from_filter = filter_counts?.[count_key];
          const from_wise =
            key === "accumulate"
              ? action_wise?.average_up?.stock_count
              : action_wise?.[key]?.stock_count;
          const count =
            key === "accumulate"
              ? from_filter ?? buy_more_stocks(stocks).length ?? from_wise ?? 0
              : from_filter ?? from_wise ?? 0;
          return (
            <div key={key} className={`portfolio_dash_action_pill is_${tone}`}>
              <span className="portfolio_dash_action_pill__title">{label}</span>
              <span className="portfolio_dash_action_pill__count">
                <strong>{count}</strong> Stocks
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function DashboardTopStocksTable({ stocks }) {
  const rows = useMemo(() => select_top_action_stocks(stocks, 0), [stocks]);

  if (!rows.length) return null;

  return (
    <div className="portfolio_dashboard__panel portfolio_dash_stocks_table">
      <h4 className="portfolio_dash_section_title">Top Stock Actions</h4>
      <div className="portfolio_dash_stocks_table__wrap">
        <table className="portfolio_dash_stocks_table__grid">
          <thead>
            <tr>
              <th>Stock</th>
              <th>Current price</th>
              <th>Change</th>
              <th>Action</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((stock) => {
              const h = stock.holding || {};
              const { label: action_label, tone: action_tone } = dashboard_action_display(stock);
              const reason =
                stock.summary ||
                stock.expert_view ||
                port_action_reason_fallback(stock.action);
              return (
                <tr key={stock.code}>
                  <td className="portfolio_dash_stocks_table__stock">{stock.name || stock.code}</td>
                  <td className="portfolio_dash_stocks_table__price">
                    {h.current_price != null
                      ? `₹${Number(h.current_price).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                      : "—"}
                  </td>
                  <td className={`portfolio_dash_stocks_table__chg ${pct_class(h.return_pct)}`}>
                    {fmt_pct(h.return_pct)}
                  </td>
                  <td>
                    <span className={`portfolio_dash_badge is_${action_tone}`}>{action_label}</span>
                  </td>
                  <td className="portfolio_dash_stocks_table__reason">{reason}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function port_action_reason_fallback(action) {
  const a = (action || "").toLowerCase();
  if (a.includes("hold")) return "Maintain position per SIHO assessment.";
  if (a.includes("average up")) return "Add on strength with favorable risk-reward.";
  if (a.includes("average down")) return "Opportunity to lower average with controlled sizing.";
  if (a.includes("exit")) return "Exit recommended to limit further downside.";
  if (a.includes("reduce") || a.includes("cut")) return "Trim exposure to manage portfolio risk.";
  return "Review detailed stock analysis for rationale.";
}

function overview_action_modifier(action) {
  const key = (action || "").toLowerCase().replace(/\s+/g, "_");
  if (key.includes("reduce") || key.includes("exit") || key.includes("cut") || key.includes("trim")) {
    return "is_reduce";
  }
  if (key.includes("hold")) return "is_hold";
  if (key.includes("accumulate") || key.includes("buy") || key.includes("average")) {
    return "is_accumulate";
  }
  return "is_default";
}

const PORTFOLIO_RATING_STAR_PATH =
  "M12 2.5l2.76 5.59 6.17.9-4.46 4.35 1.05 6.14L12 16.9l-5.52 2.58 1.05-6.14-4.46-4.35 6.17-.9L12 2.5z";

function portfolio_rating_star_fill(value, index) {
  if (value == null) return 0;
  return Math.max(0, Math.min(1, value - (index - 1)));
}

function PortfolioRatingStar({ fill }) {
  const pct = Math.round(fill * 100);
  return (
    <span className="portfolio_overview__rating_star" aria-hidden="true">
      <svg viewBox="0 0 24 24" className="portfolio_overview__rating_star_svg">
        <path d={PORTFOLIO_RATING_STAR_PATH} className="portfolio_overview__rating_star_empty" />
        <path
          d={PORTFOLIO_RATING_STAR_PATH}
          className="portfolio_overview__rating_star_filled"
          style={{ clipPath: `inset(0 ${100 - pct}% 0 0)` }}
        />
      </svg>
    </span>
  );
}

function PortfolioOverallRatingGauge({ score }) {
  const raw = parseFloat(score);
  const value = Number.isNaN(raw) ? null : Math.max(0, Math.min(5, raw));
  const display = value != null ? value.toFixed(2) : "—";
  const tone = siho_score_tone(value);

  return (
    <div
      className={`portfolio_overview__rating ${tone}`}
      aria-label={
        value != null ? `Overall portfolio rating ${display} out of 5` : "Portfolio rating unavailable"
      }
    >
      <span className="portfolio_overview__rating_lbl">Rating</span>
      <div className="portfolio_overview__rating_stars" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((n) => (
          <PortfolioRatingStar key={n} fill={portfolio_rating_star_fill(value, n)} />
        ))}
      </div>
      <strong className="portfolio_overview__rating_val">{display}</strong>
      <span className="portfolio_overview__rating_of">/ 5</span>
    </div>
  );
}

function OverviewActionGraphic({ action }) {
  const modifier = overview_action_modifier(action);
  return (
    <div className={`portfolio_overview__action_graphic ${modifier}`}>
      <div className="portfolio_overview__action_graphic_icon" aria-hidden="true">
        {modifier === "is_reduce" && (
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M12 5v14M7 14l5 5 5-5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {modifier === "is_hold" && (
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M12 20.5s-6.5-4-6.5-9a4.5 4.5 0 019 0c0 5-6.5 9-6.5 9z"
              stroke="currentColor"
              strokeWidth="1.75"
            />
          </svg>
        )}
        {modifier === "is_accumulate" && (
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M12 19V5M7 10l5-5 5 5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {modifier === "is_default" && (
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.75" />
            <path d="M12 8v4l3 2" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
          </svg>
        )}
      </div>
      <div className="portfolio_overview__action_graphic_body">
        <span className="portfolio_overview__action_graphic_lbl">Portfolio stance</span>
        <span className="portfolio_overview__action_graphic_val">{action}</span>
      </div>
    </div>
  );
}

function PortfolioOverview({ data, port, filter_counts, return_abs }) {
  const risk = port.risk || {};
  const breadth = risk.breadth || {};
  const conc = port.concentration || {};
  const sectors = conc.sectors || [];
  const action_wise = data?.action_wise_summary || {};
  const stocks = data?.stocks || [];
  const stock_count = data?.count ?? stocks.length ?? 0;

  const score_100 = portfolio_score_to_100(port.action_score);
  const score_label = portfolio_score_label(score_100);
  const fundamentals_100 = avg_stock_metric_100(stocks, "combined");
  const diversification_100 = diversification_score_100(conc, sectors);
  const risk_meter_score = compute_dashboard_risk_meter_score(filter_counts);
  const breadth_total = breadth.total_stocks ?? stock_count;
  const breadth_pct =
    breadth.stocks_in_profit != null && breadth_total
      ? Math.round((breadth.stocks_in_profit / breadth_total) * 100)
      : null;
  const score_tone = portfolio_score_visual_tone(score_100);
  const risk_action_chips = useMemo(
    () => build_dashboard_risk_chips(filter_counts),
    [filter_counts],
  );

  return (
    <div className="portfolio_overview portfolio_overview--mock">
      <div className="portfolio_overview__page_head">
        <h2 className="portfolio_overview__page_title">Portfolio Overview</h2>
        <span className="portfolio_overview__updated">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
            <path d="M8 3v4M16 3v4M3 10h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          Last Updated: {format_dashboard_updated()}
        </span>
      </div>

      <div className="portfolio_overview__summary_kpis">
        <div className="portfolio_dash_summary_card is_value">
          <DashboardSummaryKpiHead variant="value" label="Portfolio Value" />
          <div className="portfolio_dash_summary_card__metrics">
            <div className="portfolio_dash_summary_card__val">{fmt_inr_full(port.current_value)}</div>
            {return_abs != null && port.return_pct != null && (
              <div className={`portfolio_dash_summary_card__extra ${pct_class(port.return_pct)}`}>
                {fmt_pct(port.return_pct)} · {fmt_inr_full(return_abs, true)}
              </div>
            )}
          </div>
        </div>
        <div className="portfolio_dash_summary_card is_score">
          <DashboardSummaryKpiHead variant="score" label="Portfolio Score" />
          <div className="portfolio_dash_summary_card__metrics">
            <div className="portfolio_dash_summary_card__val portfolio_dash_summary_card__val--score">
              <span className="portfolio_dash_summary_card__val_main">
                {score_100 != null ? score_100 : "—"}
              </span>
              <span className="portfolio_dash_summary_card__val_suffix">/100</span>
            </div>
            <div className={`portfolio_dash_summary_card__tag ${score_tone}`}>{score_label}</div>
            {score_100 != null && (
              <div className="portfolio_dash_summary_card__bar">
                <span
                  className={`portfolio_dash_summary_card__bar_fill ${score_tone}`}
                  style={{ width: `${score_100}%` }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="portfolio_dash_summary_card is_returns">
          <DashboardSummaryKpiHead variant="returns" label="Overall Returns" />
          <div className="portfolio_dash_summary_card__metrics">
            <div className={`portfolio_dash_summary_card__val is_return ${pct_class(port.return_pct)}`}>
              {port.return_pct != null ? fmt_pct(port.return_pct) : "—"}
            </div>
            {return_abs != null && (
              <div className={`portfolio_dash_summary_card__extra ${pct_class(return_abs)}`}>
                {fmt_inr_full(return_abs, true)}
              </div>
            )}
          </div>
        </div>
        <div className="portfolio_dash_summary_card is_invested">
          <DashboardSummaryKpiHead variant="invested" label="Total Invested" />
          <div className="portfolio_dash_summary_card__metrics">
            <div className="portfolio_dash_summary_card__val">{fmt_inr_full(port.total_invested)}</div>
          </div>
        </div>
      </div>

      <div className="portfolio_overview__analytics portfolio_overview__analytics--split portfolio_overview__analytics--compact">
        <div className="portfolio_overview__analytics_top">
          <div className="portfolio_dash_panel portfolio_dash_panel--score">
            <h4 className="portfolio_dash_panel__title">Portfolio Score</h4>
            <div className="portfolio_dash_panel--score_body">
              <div className="portfolio_dash_panel--score_inner">
                <ScoreDonutChart score={score_100} label={score_label} />
                <div className="portfolio_dash_score_metrics">
                  <ScoreMetricBar label="Diversification" value={diversification_100} />
                  <ScoreMetricBar label="Risk" value={risk_meter_score} />
                  <ScoreMetricBar label="Fundamentals" value={fundamentals_100} />
                </div>
              </div>
            </div>
          </div>

          <div className="portfolio_dash_panel portfolio_dash_panel--sector is_wide">
            <div className="portfolio_dash_panel__head_row portfolio_dash_panel__head_row--sector">
              <div className="portfolio_dash_panel__head_stack">
                <h4 className="portfolio_dash_panel__title">Sector Allocation</h4>
                {conc.detail && (
                  <p className="portfolio_dash_panel__hint_inline">
                    {format_portfolio_summary(conc.detail)}
                  </p>
                )}
              </div>
            </div>
            <div className="portfolio_dash_panel--sector_body">
              <SectorPieChart sectors={sectors} />
            </div>
          </div>
        </div>

        <div className="portfolio_overview__analytics_bottom">
          <PortfolioMeterPanel
            title="Risk"
            variant="risk"
            badge_label={null}
            summary_text={risk_meter_summary_text(risk_meter_score, filter_counts)}
            pct={risk_meter_score}
            meter_scale="risk"
            color_mode="risk"
            display={risk_meter_score != null ? `${risk_meter_score}/100` : "—"}
            value_hint="Action mix by risk — buy more (low), hold (moderate), defensive actions (high)"
            scale_low_label="0"
            scale_high_label="100"
            chips={risk_action_chips.filter((chip) => chip.label !== "Moderate risk")}
          />
          <PortfolioMeterPanel
            title="Breadth"
            variant="breadth"
            badge_label={null}
            summary_text={breadth.detail || breadth.signal}
            pct={breadth_pct}
            meter_scale="percent"
            display={breadth_pct != null ? `${breadth_pct}%` : "—"}
            value_hint="% of your holdings that are in profit right now"
            scale_low_label="0%"
            scale_high_label="100%"
            chips={[
              { label: "Profit", value: breadth.stocks_in_profit ?? "—", tone: "pos" },
              { label: "Loss", value: breadth.stocks_in_loss ?? "—", tone: "neg" },
            ]}
          />
        </div>
      </div>

      <PortfolioOverviewChart port={port} stocks={stocks} />

      <DashboardActionPills
        filter_counts={filter_counts}
        action_wise={action_wise}
        stocks={stocks}
      />

      <DashboardTopStocksTable stocks={stocks} />
    </div>
  );
}

function ExecutionPlanPage({ data }) {
  const action_summary = data?.action_summary || {};
  const action_wise = data?.action_wise_summary || {};
  const stocks = data?.stocks || [];
  const filter_counts = useMemo(() => count_by_filter(stocks), [stocks]);
  const tpp = data?.three_phase_portfolio;

  return (
    <div className="portfolio_overview portfolio_execution_page">
      <div className="portfolio_overview__head">
        <div>
          <h2 className="portfolio_overview__title">Execution plan</h2>
          <p className="portfolio_overview__sub">
            Three-phase rollout and action-wise capital impact
          </p>
        </div>
      </div>

      {tpp ? (
        <ThreePhasePortfolioPanel
          three_phase_portfolio={tpp}
          className="portfolio_tph--page"
        />
      ) : (
        <div className="portfolio_dashboard__detail_empty">No execution plan data available.</div>
      )}

      <ActionWiseSummaryPanel
        action_wise={action_wise}
        stocks={stocks}
        action_summary={action_summary}
        filter_counts={filter_counts}
      />

      <NetImpactSummaryPanel action_summary={action_summary} />
    </div>
  );
}

const REPORT_INCLUDES = [
  "Portfolio overview — invested, market value, returns, CAGR & alpha",
  "Holdings table — stock name, recommendation & SIHO score",
  "Action-wise summary — buy more, average down, cut loss, book profit, exit & hold",
  "Net impact — combined proceeds, profit/loss booked, capital deployment",
  "Three-phase execution plan — phased cut loss & average down (when applicable)",
];

function ReportsPage({ data, on_download, port = {}, filter_counts = {} }) {
  const stock_count = data?.count ?? data?.stocks?.length ?? 0;
  const has_three_phase = !!data?.three_phase_portfolio;
  const action_buckets = PRINT_ACTION_SECTIONS.filter(({ aws_key, count_key }) => {
    if (count_key) return (filter_counts[count_key] ?? 0) > 0;
    const block = aws_key ? data?.action_wise_summary?.[aws_key] : null;
    return (block?.stock_count ?? 0) > 0;
  }).length;

  const includes = REPORT_INCLUDES.filter((line) =>
    line.startsWith("Three-phase") ? has_three_phase : true
  );

  return (
    <div className="portfolio_reports_page">
      <div className="portfolio_reports_hero">
        <div className="portfolio_reports_hero__copy">
          <h2 className="portfolio_reports_hero__title">Portfolio report</h2>
          <p className="portfolio_reports_hero__sub">
            Professional PDF-ready summary for {stock_count} holding
            {stock_count === 1 ? "" : "s"} in this analysis.
          </p>
        </div>
        <button
          type="button"
          className="portfolio_dashboard__btn portfolio_dashboard__btn_primary portfolio_reports_hero__btn"
          onClick={on_download}
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" width="18" height="18">
            <path
              d="M12 4v10m0 0l3.5-3.5M12 14l-3.5-3.5M5 18h14"
              stroke="currentColor"
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Download report
        </button>
      </div>

      <div className="portfolio_reports_stats">
        <div className="portfolio_reports_stat">
          <span className="portfolio_reports_stat__lbl">Holdings</span>
          <strong className="portfolio_reports_stat__val">{stock_count}</strong>
        </div>
        <div className="portfolio_reports_stat">
          <span className="portfolio_reports_stat__lbl">Invested</span>
          <strong className="portfolio_reports_stat__val">{fmt_inr(port.total_invested)}</strong>
        </div>
        <div className="portfolio_reports_stat">
          <span className="portfolio_reports_stat__lbl">Market value</span>
          <strong className="portfolio_reports_stat__val">{fmt_inr(port.current_value)}</strong>
        </div>
        <div className="portfolio_reports_stat">
          <span className="portfolio_reports_stat__lbl">Total return</span>
          <strong className={`portfolio_reports_stat__val ${pct_class(port.return_pct)}`}>
            {port.return_pct != null ? fmt_pct(port.return_pct) : "—"}
          </strong>
        </div>
        <div className="portfolio_reports_stat">
          <span className="portfolio_reports_stat__lbl">Active actions</span>
          <strong className="portfolio_reports_stat__val">{action_buckets}</strong>
        </div>
      </div>

      <div className="portfolio_reports_grid">
        <div className="portfolio_reports_card">
          <h3 className="portfolio_reports_card__title">What&apos;s inside</h3>
          <ul className="portfolio_reports_list">
            {includes.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </div>
        <div className="portfolio_reports_card portfolio_reports_card--tip">
          <h3 className="portfolio_reports_card__title">How to save as PDF</h3>
          <ol className="portfolio_reports_steps">
            <li>Click <strong>Download report</strong></li>
            <li>In the print dialog, choose <strong>Save as PDF</strong></li>
            <li>Set margins to <strong>Default</strong> and enable <strong>Background graphics</strong></li>
          </ol>
          <button
            type="button"
            className="portfolio_dashboard__btn portfolio_dashboard__btn_secondary portfolio_reports_card__btn"
            onClick={on_download}
          >
            Open print preview
          </button>
        </div>
      </div>
    </div>
  );
}

function PortfolioBenchmarkBarChart({ port }) {
  const bars = [
    { label: "Portfolio", value: parseFloat(port.return_pct), tone: "portfolio" },
    { label: "Nifty CAGR", value: parseFloat(port.nifty_cagr_pct), tone: "nifty" },
    { label: "Alpha", value: parseFloat(port.alpha_pct), tone: "alpha" },
  ].filter((bar) => !Number.isNaN(bar.value));

  if (!bars.length) {
    return <p className="portfolio_chart__empty">Return comparison data is not available.</p>;
  }

  const width = 520;
  const height = 200;
  const pad = { top: 20, right: 20, bottom: 36, left: 48 };
  const inner_w = width - pad.left - pad.right;
  const inner_h = height - pad.top - pad.bottom;
  const bar_gap = 28;
  const bar_w = (inner_w - bar_gap * (bars.length - 1)) / bars.length;

  const values = bars.map((b) => b.value);
  let y_min = Math.min(0, ...values);
  let y_max = Math.max(0, ...values);
  const y_pad = Math.max(6, (y_max - y_min) * 0.18);
  y_min -= y_pad;
  y_max += y_pad;
  const y_span = y_max - y_min || 1;
  const y_at = (value) => pad.top + inner_h - ((value - y_min) / y_span) * inner_h;
  const zero_y = y_at(0);

  return (
    <div className="portfolio_chart portfolio_chart--bars">
      <svg viewBox={`0 0 ${width} ${height}`} className="portfolio_chart__svg" role="img" aria-label="Portfolio vs Nifty returns">
        <line
          x1={pad.left}
          y1={zero_y}
          x2={width - pad.right}
          y2={zero_y}
          className="portfolio_chart__zero"
        />
        {bars.map((bar, i) => {
          const x = pad.left + i * (bar_w + bar_gap);
          const y = y_at(bar.value);
          const bar_h = Math.abs(zero_y - y);
          const bar_y = bar.value >= 0 ? y : zero_y;
          return (
            <g key={bar.label}>
              <rect
                x={x}
                y={bar_y}
                width={bar_w}
                height={Math.max(bar_h, 2)}
                rx="6"
                className={`portfolio_overview_bar is_${bar.tone}${bar.value < 0 ? " is_neg" : ""}`}
              />
              <text
                x={x + bar_w / 2}
                y={bar.value >= 0 ? bar_y - 6 : bar_y + bar_h + 14}
                className="portfolio_overview_bar__val"
                textAnchor="middle"
              >
                {fmt_pct(bar.value)}
              </text>
              <text
                x={x + bar_w / 2}
                y={height - 12}
                className="portfolio_chart__axis_label"
                textAnchor="middle"
              >
                {bar.label}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}

function PortfolioOverviewChart({ port, stocks }) {
  const period_vs_nifty = useMemo(() => build_portfolio_period_vs_nifty(stocks), [stocks]);
  const has_line = period_vs_nifty != null;

  return (
    <div className="portfolio_overview__chart_section portfolio_dash_panel portfolio_dash_panel--chart">
      <div className="portfolio_overview__chart_head">
        <div className="portfolio_overview__chart_head_text">
          <h4 className="portfolio_overview__chart_title">Portfolio performance</h4>
          <p className="portfolio_overview__chart_sub">
            {has_line
              ? "Weighted portfolio return vs Nifty across periods"
              : "Overall portfolio return vs Nifty benchmark"}
          </p>
        </div>
        {port.alpha_pct != null && !Number.isNaN(parseFloat(port.alpha_pct)) && (
          <span className={`portfolio_overview_chart_alpha ${pct_class(port.alpha_pct)}`}>
            Alpha {fmt_pct(port.alpha_pct)}
          </span>
        )}
      </div>
      <div className="portfolio_overview__chart_body">
        {has_line ? (
          <PeriodVsNiftyChart
            period_vs_nifty={period_vs_nifty}
            compact
            premium
            stock_label="Portfolio"
            nifty_label="Nifty"
          />
        ) : (
          <PortfolioBenchmarkBarChart port={port} />
        )}
      </div>
    </div>
  );
}

function chart_smooth_control(points, index) {
  const p0 = points[Math.max(0, index - 1)];
  const p1 = points[index];
  const p2 = points[index + 1];
  const p3 = points[Math.min(points.length - 1, index + 2)];
  const tension = 0.32;
  return {
    cp1x: p1.x + (p2.x - p0.x) * tension,
    cp1y: p1.y + (p2.y - p0.y) * tension,
    cp2x: p2.x - (p3.x - p1.x) * tension,
    cp2y: p2.y - (p3.y - p1.y) * tension,
  };
}

function build_chart_smooth_path(points) {
  if (!points.length) return "";
  if (points.length === 1) return `M ${points[0].x} ${points[0].y}`;
  let path = `M ${points[0].x} ${points[0].y}`;
  for (let i = 0; i < points.length - 1; i += 1) {
    const { cp1x, cp1y, cp2x, cp2y } = chart_smooth_control(points, i);
    const end = points[i + 1];
    path += ` C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${end.x} ${end.y}`;
  }
  return path;
}

function build_chart_area_path(points, baseline_y) {
  if (!points.length) return "";
  const line = build_chart_smooth_path(points);
  const last = points[points.length - 1];
  const first = points[0];
  return `${line} L ${last.x} ${baseline_y} L ${first.x} ${baseline_y} Z`;
}

const CHART_TOOLTIP_W = 156;
const CHART_TOOLTIP_H = 62;
const CHART_HIT_MIN_W = 80;

function chart_period_hit_band(index, count, x_at, pad, width) {
  const x = x_at(index);
  if (count === 1) {
    return { x: pad.left, width: width - pad.left - pad.right, cx: x };
  }

  let x0;
  let x1;
  if (index === 0) {
    x0 = pad.left;
    x1 = (x + x_at(1)) / 2;
  } else if (index === count - 1) {
    x0 = (x_at(index - 1) + x) / 2;
    x1 = width - pad.right;
  } else {
    x0 = (x_at(index - 1) + x) / 2;
    x1 = (x_at(index + 1) + x) / 2;
  }

  const width_band = Math.max(CHART_HIT_MIN_W, x1 - x0);
  const cx = (x0 + x1) / 2;
  return { x: cx - width_band / 2, width: width_band, cx: x };
}

function chart_tooltip_x(point_x, width, pad, tooltip_w = CHART_TOOLTIP_W) {
  const right_limit = width - pad.right - tooltip_w - 8;
  const left_limit = pad.left + 8;
  const prefer_left = point_x > width * 0.62;
  const x = prefer_left ? point_x - tooltip_w - 14 : point_x + 14;
  return Math.min(Math.max(x, left_limit), right_limit);
}

function PeriodVsNiftyChart({
  period_vs_nifty,
  compact = false,
  premium = false,
  stock_label = "Stock return",
  nifty_label = "Nifty return",
}) {
  const uid = useId().replace(/:/g, "");
  const fill_id = `chart-fill-${uid}`;
  const stock_glow_id = `chart-glow-stock-${uid}`;
  const chart_ref = useRef(null);
  const series = useMemo(() => get_period_vs_nifty_series(period_vs_nifty), [period_vs_nifty]);
  const [selected_idx, set_selected_idx] = useState(null);

  useEffect(() => {
    if (selected_idx == null) return undefined;
    const on_doc_pointer = (event) => {
      if (!chart_ref.current?.contains(event.target)) {
        set_selected_idx(null);
      }
    };
    document.addEventListener("pointerdown", on_doc_pointer);
    return () => document.removeEventListener("pointerdown", on_doc_pointer);
  }, [selected_idx]);

  if (!series.length) {
    return <p className="portfolio_chart__empty">Period vs Nifty data is not available for this stock.</p>;
  }

  const is_premium = premium || compact;
  const width = is_premium ? 1000 : 680;
  const height = is_premium ? 236 : 280;
  const pad = is_premium
    ? { top: 28, right: 28, bottom: 48, left: 58 }
    : { top: 28, right: 28, bottom: 48, left: 56 };
  const inner_w = width - pad.left - pad.right;
  const inner_h = height - pad.top - pad.bottom;
  const baseline_y = pad.top + inner_h;

  const all_values = series.flatMap((row) => [row.stock, row.nifty]).filter((v) => !Number.isNaN(v));
  let y_min = Math.min(0, ...all_values);
  let y_max = Math.max(0, ...all_values);
  const y_pad = Math.max(6, (y_max - y_min) * 0.12);
  y_min -= y_pad;
  y_max += y_pad;
  const y_span = y_max - y_min || 1;

  const x_at = (index) =>
    pad.left + (series.length === 1 ? inner_w / 2 : (index / (series.length - 1)) * inner_w);
  const y_at = (value) => pad.top + inner_h - ((value - y_min) / y_span) * inner_h;

  const stock_points = series.map((row, i) => ({ x: x_at(i), y: y_at(row.stock) }));
  const nifty_points = series.map((row, i) => ({ x: x_at(i), y: y_at(row.nifty) }));
  const stock_path = build_chart_smooth_path(stock_points);
  const nifty_path = build_chart_smooth_path(nifty_points);
  const area_path = build_chart_area_path(stock_points, baseline_y);

  const y_ticks = 4;
  const y_labels = Array.from({ length: y_ticks + 1 }, (_, i) => {
    const value = y_max - (i / y_ticks) * y_span;
    return { value, y: y_at(value) };
  });

  const active_idx = selected_idx;
  const active = active_idx != null ? series[active_idx] : null;
  const tooltip_x = active ? chart_tooltip_x(x_at(active_idx), width, pad) : 0;

  const on_period_select = (index) => {
    set_selected_idx((prev) => (prev === index ? null : index));
  };

  return (
    <div
      ref={chart_ref}
      className={`portfolio_chart${compact ? " is_compact" : ""}${is_premium ? " is_premium" : ""}`}
    >
      <div className="portfolio_chart__legend">
        <span className="portfolio_chart__legend_item is_stock">
          <span className="portfolio_chart__legend_dot" />
          {stock_label}
        </span>
        <span className="portfolio_chart__legend_item is_nifty">
          <span className="portfolio_chart__legend_dot" />
          {nifty_label}
        </span>
      </div>
      <div className="portfolio_chart__plot">
        <svg
          viewBox={`0 0 ${width} ${height}`}
          preserveAspectRatio="none"
          className="portfolio_chart__svg"
          role="img"
          aria-label="Stock vs Nifty returns by period"
        >
          <defs>
            <linearGradient id={fill_id} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#2563eb" stopOpacity="0.28" />
              <stop offset="55%" stopColor="#3b82f6" stopOpacity="0.1" />
              <stop offset="100%" stopColor="#60a5fa" stopOpacity="0" />
            </linearGradient>
            <filter id={stock_glow_id} x="-20%" y="-20%" width="140%" height="140%">
              <feGaussianBlur stdDeviation="2" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          {y_labels.map((tick) => (
            <g key={tick.value}>
              <line
                x1={pad.left}
                y1={tick.y}
                x2={width - pad.right}
                y2={tick.y}
                className="portfolio_chart__grid"
              />
              <text
                x={pad.left - 12}
                y={tick.y + 4}
                className="portfolio_chart__axis_label"
                textAnchor="end"
              >
                {fmt_pct(tick.value, false)}
              </text>
            </g>
          ))}
          <line
            x1={pad.left}
            y1={y_at(0)}
            x2={width - pad.right}
            y2={y_at(0)}
            className="portfolio_chart__zero"
          />
          <path d={area_path} fill={`url(#${fill_id})`} className="portfolio_chart__area" />
          <path d={nifty_path} className="portfolio_chart__line is_nifty" fill="none" />
          <path
            d={stock_path}
            className="portfolio_chart__line is_stock"
            fill="none"
            filter={`url(#${stock_glow_id})`}
          />
          {series.map((row, i) => {
            const x = x_at(i);
            const is_active = active_idx === i;
            return (
              <g key={row.period} pointerEvents="none">
                <text
                  x={x}
                  y={height - 18}
                  className="portfolio_chart__axis_label is_period"
                  textAnchor="middle"
                >
                  {row.period}
                </text>
                <circle
                  cx={x}
                  cy={y_at(row.nifty)}
                  r={is_active ? 5.5 : 4}
                  className="portfolio_chart__point is_nifty"
                />
                <circle
                  cx={x}
                  cy={y_at(row.stock)}
                  r={is_active ? 7 : 5}
                  className="portfolio_chart__point is_stock"
                />
                {is_active && (
                  <circle cx={x} cy={y_at(row.stock)} r={11} className="portfolio_chart__point_halo is_stock" />
                )}
              </g>
            );
          })}
          {active && (
            <g className="portfolio_chart__hover_layer" pointerEvents="none">
              <line
                x1={x_at(active_idx)}
                y1={pad.top}
                x2={x_at(active_idx)}
                y2={baseline_y}
                className="portfolio_chart__marker"
              />
              <rect
                x={tooltip_x}
                y={pad.top + 10}
                width={CHART_TOOLTIP_W}
                height={CHART_TOOLTIP_H}
                rx="10"
                className="portfolio_chart__tooltip"
              />
              <text x={tooltip_x + 14} y={pad.top + 30} className="portfolio_chart__tooltip_title">
                {active.period.toUpperCase()}
              </text>
              <text x={tooltip_x + 14} y={pad.top + 46} className="portfolio_chart__tooltip_stock">
                {stock_label} {fmt_pct(active.stock)}
              </text>
              <text x={tooltip_x + 14} y={pad.top + 60} className="portfolio_chart__tooltip_nifty">
                {nifty_label} {fmt_pct(active.nifty)}
              </text>
            </g>
          )}
          {series.map((row, i) => {
            const x = x_at(i);
            const hit = chart_period_hit_band(i, series.length, x_at, pad, width);
            const is_active = active_idx === i;
            return (
              <g key={`${row.period}-hit`} className="portfolio_chart__period_hit">
                <rect
                  x={hit.x}
                  y={pad.top}
                  width={hit.width}
                  height={inner_h}
                  fill="transparent"
                  className="portfolio_chart__hit"
                  role="button"
                  tabIndex={0}
                  aria-label={`${row.period} returns`}
                  aria-pressed={is_active}
                  onClick={() => on_period_select(i)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      on_period_select(i);
                    }
                  }}
                />
                <circle
                  cx={x}
                  cy={y_at(row.stock)}
                  r={18}
                  fill="transparent"
                  className="portfolio_chart__hit_dot"
                  role="presentation"
                  onClick={() => on_period_select(i)}
                />
              </g>
            );
          })}
        </svg>
      </div>
    </div>
  );
}

function SihoScoresCard({ scores, layout = "grid" }) {
  const all_rows = [
    { label: "Combined", key: "combined", highlight: true },
    { label: "Fundamental", key: "fundamental_present" },
    { label: "Future", key: "fundamental_future" },
    { label: "Technical", key: "technical" },
  ];
  const rows = all_rows;

  return (
    <div className="portfolio_detail_card portfolio_siho_scores">
      <h4 className="portfolio_detail_card__title">SIHO score</h4>
      <div className={`portfolio_siho_scores__grid${layout === "row" ? " is_row" : ""}`}>
        {rows.map(({ label, key, highlight }) => {
          const value = scores?.[key];
          const num = parseFloat(value);
          return (
            <div
              key={key}
              className={`portfolio_siho_scores__item${highlight ? " is_highlight" : ""}`}
            >
              <span className="portfolio_siho_scores__label">{label}</span>
              <div className="portfolio_siho_scores__score_line">
                <strong className="portfolio_siho_scores__val">
                  {Number.isNaN(num) ? "—" : num.toFixed(2)}
                </strong>
                <span className="portfolio_siho_scores__of">/ 5</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function PortfolioImpactSummary({ summary }) {
  if (!summary) return null;
  const parts = split_impact_summary_parts(summary);

  return (
    <div className="portfolio_impact_summary">
      <p className="portfolio_impact_summary__text">
        {parts.map((part, idx) =>
          part.type === "num" ? (
            <strong key={idx} className="portfolio_impact_summary__highlight">
              {part.value}
            </strong>
          ) : (
            <span key={idx}>{part.value}</span>
          )
        )}
      </p>
    </div>
  );
}

function PortfolioImpactCard({ portfolio_impact }) {
  if (!portfolio_impact) return null;

  return (
    <div className="portfolio_detail_card portfolio_impact_card">
      <h4 className="portfolio_detail_card__title">Portfolio impact</h4>
      <div className="portfolio_impact_card__chips">
        {portfolio_impact.impact_tier && (
          <span className="portfolio_impact_card__chip">{portfolio_impact.impact_tier}</span>
        )}
        {portfolio_impact.role && (
          <span className="portfolio_impact_card__chip is_muted">{portfolio_impact.role}</span>
        )}
      </div>
      <div className="portfolio_impact_card__metrics">
        {portfolio_impact.weight_pct != null && (
          <div>
            <span>Weight</span>
            <strong>{Number(portfolio_impact.weight_pct).toFixed(2)}%</strong>
          </div>
        )}
        {portfolio_impact.mctr_pct != null && (
          <div>
            <span>MCTR</span>
            <strong>{Number(portfolio_impact.mctr_pct).toFixed(1)}%</strong>
          </div>
        )}
        {portfolio_impact.correlation_with_portfolio != null && (
          <div>
            <span>Correlation</span>
            <strong>{Number(portfolio_impact.correlation_with_portfolio).toFixed(2)}</strong>
          </div>
        )}
        {portfolio_impact.stress_30pct_drop_pct != null && (
          <div>
            <span>30% drop stress</span>
            <strong className="neg">{Number(portfolio_impact.stress_30pct_drop_pct).toFixed(1)}%</strong>
          </div>
        )}
      </div>
    </div>
  );
}

function format_holding_symbol_label(stock) {
  const { nse_code, bse_code } = get_stock_exchange_codes(stock);
  const parts = [];
  if (nse_code) parts.push(`NSE ${nse_code}`);
  if (bse_code) parts.push(`BSE ${bse_code}`);
  if (!parts.length && stock.code) parts.push(stock.code);
  return parts.join(" · ") || "—";
}

function PortfolioHoldingsTable({ stocks, on_select_stock }) {
  return (
    <div className="portfolio_holdings_table">
      <div className="portfolio_holdings_table__wrap">
        <table className="portfolio_holdings_table__grid">
          <thead>
            <tr>
              <th>Stock</th>
              <th>Recommendation</th>
              <th>Symbol</th>
              <th>Sector</th>
              <th>ISIN</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Invested</th>
              <th>Return</th>
              <th>SIHO Score</th>
              <th aria-label="Actions" />
            </tr>
          </thead>
          <tbody>
            {stocks.map((stock) => {
              const h = stock.holding || {};
              const scores = stock.scores || {};
              const price_label =
                h.current_price != null
                  ? `₹${Number(h.current_price).toLocaleString("en-IN")}`
                  : "—";
              const score_label =
                scores.combined != null ? `${Number(scores.combined).toFixed(2)}/5` : "—";

              return (
                <tr key={stock.code}>
                  <td className="portfolio_holdings_table__stock">{stock.name || stock.code}</td>
                  <td>
                    <span className={action_badge_class(stock.action)}>{action_badge_label(stock)}</span>
                  </td>
                  <td className="portfolio_holdings_table__symbol">
                    {format_holding_symbol_label(stock)}
                  </td>
                  <td>{stock.industry_group || "—"}</td>
                  <td className="portfolio_holdings_table__isin">
                    {stock.isin ? `ISIN ${stock.isin}` : "—"}
                  </td>
                  <td className="portfolio_holdings_table__price pos">{price_label}</td>
                  <td className="portfolio_holdings_table__num">
                    {h.qty != null ? fmt_num(h.qty) : "—"}
                  </td>
                  <td className="portfolio_holdings_table__num">{fmt_inr(h.total_investment)}</td>
                  <td className={`portfolio_holdings_table__return ${pct_class(h.return_pct)}`}>
                    {fmt_pct(h.return_pct)}
                  </td>
                  <td className="portfolio_holdings_table__score">{score_label}</td>
                  <td className="portfolio_holdings_table__action">
                    <button
                      type="button"
                      className="portfolio_holdings_table__detail_btn"
                      onClick={() => on_select_stock(stock.code)}
                    >
                      View detail
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function fmt_price_inr(n) {
  const v = parseFloat(n);
  if (Number.isNaN(v)) return "—";
  return `₹${v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function AnalysisDetailRow({ label, value, value_class = "" }) {
  if (value == null || value === "") return null;
  return (
    <div className="portfolio_analysis_row">
      <span className="portfolio_analysis_row__lbl">{label}</span>
      <span className={`portfolio_analysis_row__val${value_class ? ` ${value_class}` : ""}`}>
        {value}
      </span>
    </div>
  );
}

function AnalysisSection({ icon, title, is_empty, children, default_open = false }) {
  if (is_empty) return null;

  return (
    <details className="portfolio_analysis_dropdown" open={default_open || undefined}>
      <summary className="portfolio_analysis_dropdown__summary">
        <span className="portfolio_analysis_dropdown__icon" aria-hidden="true">
          {icon}
        </span>
        <span className="portfolio_analysis_dropdown__title">{title}</span>
        <span className="portfolio_analysis_dropdown__chev" aria-hidden="true">
          ▾
        </span>
      </summary>
      <div className="portfolio_analysis_dropdown__body">{children}</div>
    </details>
  );
}

function siho_score_tone(value) {
  const n = parseFloat(value);
  if (Number.isNaN(n)) return "is_muted";
  if (n >= 4) return "is_high";
  if (n >= 3) return "is_mid";
  return "is_low";
}

function SihoScoresPanel({ scores, icon = "⭐" }) {
  const items = [
    { label: "Fundamental", key: "fundamental_present" },
    { label: "Future outlook", key: "fundamental_future" },
    { label: "Technical", key: "technical" },
    { label: "Combined", key: "combined", highlight: true },
  ];

  return (
    <section className="portfolio_expert_section portfolio_siho_scores_panel">
      <h4 className="portfolio_expert_section__title">
        <span className="portfolio_expert_section__icon" aria-hidden="true">
          {icon}
        </span>
        SIHO scores
      </h4>
      <div className="portfolio_siho_scores_grid">
        {items.map(({ label, key, highlight }) => {
          const n = parseFloat(scores?.[key]);
          const tone = siho_score_tone(scores?.[key]);
          return (
            <div
              key={key}
              className={`portfolio_siho_score_card ${tone}${highlight ? " is_combined" : ""}`}
            >
              <span className="portfolio_siho_score_card__lbl">{label}</span>
              <div className="portfolio_siho_score_card__val">
                <strong>{Number.isNaN(n) ? "—" : n.toFixed(2)}</strong>
                <small>/ 5</small>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

function ExpertNarrativeSection({ title, text, icon }) {
  if (!text) return null;
  return (
    <section className="portfolio_expert_section">
      <h4 className="portfolio_expert_section__title">
        {icon && (
          <span className="portfolio_expert_section__icon" aria-hidden="true">
            {icon}
          </span>
        )}
        {title}
      </h4>
      <p className="portfolio_expert_section__text">{text}</p>
    </section>
  );
}

const ACTION_ITEM_FIELD_ROWS = [
  { key: "sell_qty", label: "Units to sell" },
  { key: "buy_qty", label: "Units to buy" },
  { key: "proceeds", label: "Est. proceeds", format: "inr" },
  { key: "capital_required", label: "Capital required", format: "inr" },
  { key: "cost_basis_sold", label: "Cost basis (sold portion)", format: "inr" },
  { key: "profit_booked", label: "Profit booked (est.)", format: "inr", tone: "pos" },
  { key: "loss_booked", label: "Loss booked (est.)", format: "inr", tone: "neg" },
  { key: "remaining_qty", label: "Remaining qty" },
  { key: "remaining_invested", label: "Remaining invested", format: "inr" },
  { key: "remaining_market_value", label: "Remaining value", format: "inr" },
  { key: "new_avg_buy_price", label: "New avg buy price", format: "inr" },
  { key: "new_total_qty", label: "New total qty" },
  { key: "new_invested", label: "New invested", format: "inr" },
  { key: "new_market_value", label: "New market value", format: "inr" },
 
];

function format_action_item_value(value, format) {
  if (value == null || value === "") return null;
  if (format === "inr") return fmt_inr(value);
  // if (format === "scenario") return String(value);
  const num = parseFloat(value);
  if (!Number.isNaN(num) && String(value).trim() !== "") {
    return fmt_num(value);
  }
  return String(value);
}

/** Recommended trade metrics from upload JSON — shown on all action pages except Buy More. */
function ActionItemCard({ stock }) {
  if (stock_filter_key(stock) === "accumulate") return null;

  const af = stock?.action_financials;
  if (!af || typeof af !== "object") return null;

  const rows = ACTION_ITEM_FIELD_ROWS.map(({ key, label, format, tone }) => {
    const display = format_action_item_value(af[key], format);
    if (display == null) return null;
    return { key, label, display, tone };
  }).filter(Boolean);

  if (!rows.length) return null;

  return (
    <section className="portfolio_action_item_card" aria-label="Action item">
      <h3 className="portfolio_action_item_card__title">Action item</h3>
      <dl className="portfolio_action_item_card__grid">
        {rows.map((row) => (
          <div key={row.key} className="portfolio_action_item_card__row">
            <dt>{row.label}</dt>
            <dd className={row.tone || ""}>{row.display}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}

function stock_initials(stock) {
  const name = (stock?.name || stock?.code || "").trim();
  if (!name) return "—";
  const words = name.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    return `${words[0][0] || ""}${words[1][0] || ""}`.toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

function action_section_sidebar_title(active_filter, section_label) {
  const titles = {
    accumulate: "STOCKS TO BUY",
    average_down: "STOCKS TO AVERAGE DOWN",
    cut_loss: "STOCKS TO CUT LOSS",
    exit: "STOCKS TO EXIT",
    hold: "STOCKS TO HOLD",
    profit_booking: "STOCKS TO BOOK PROFIT",
  };
  return titles[active_filter] || `${(section_label || "Stocks").toUpperCase()}`;
}

const SIDEBAR_CHIP_FILTERS = [
  { id: "all", label: "All" },
  { id: "accumulate", label: "Accumulate" },
  { id: "buy", label: "Buy" },
  { id: "watch", label: "Watch" },
  { id: "loss", label: "🔴 Loss" },
  { id: "profit", label: "🟢 Profit" },
];

const SIDEBAR_SORT_OPTIONS = [
  { id: "default", label: "Default" },
  { id: "return_asc", label: "Return ↑" },
  { id: "return_desc", label: "Return ↓" },
  { id: "name", label: "Name A–Z" },
  { id: "siho", label: "SIHO Score" },
];

function sidebar_stock_return_pct(stock) {
  const raw = stock?.holding?.return_pct ?? stock?.return_pct;
  const value = parseFloat(raw);
  return Number.isNaN(value) ? null : value;
}

function sidebar_stock_siho_score(stock) {
  const raw = stock?.scores?.combined ?? stock?.siho_score;
  const value = parseFloat(raw);
  return Number.isNaN(value) ? null : value;
}

function sidebar_stock_chip_category(stock) {
  const action = (stock?.action || "").toLowerCase().replace(/_/g, " ");
  if (action === "hold" || stock?.conditional_action) return "watch";
  if (action.includes("accumulate")) return "accumulate";

  const buy_units = parseFloat(stock?.quantity_advice?.approx_units);
  const direction = (stock?.quantity_advice?.direction || "").toLowerCase();
  const has_buy_qty = !Number.isNaN(buy_units) && buy_units > 0 && direction === "buy";

  if (has_buy_qty || action.includes("average down") || action.includes("average up")) {
    return "buy";
  }
  return "watch";
}

function matches_sidebar_chip_filter(stock, chip_id) {
  if (chip_id === "all") return true;
  if (chip_id === "loss") {
    const ret = sidebar_stock_return_pct(stock);
    return ret != null && ret < 0;
  }
  if (chip_id === "profit") {
    const ret = sidebar_stock_return_pct(stock);
    return ret != null && ret > 0;
  }
  return sidebar_stock_chip_category(stock) === chip_id;
}

function sort_sidebar_stocks(stocks, sort_key, order_index = null) {
  const list = [...(stocks || [])];
  if (!sort_key || sort_key === "default") {
    if (!order_index) return list;
    return list.sort(
      (a, b) =>
        (order_index.get(a.code) ?? Number.MAX_SAFE_INTEGER) -
        (order_index.get(b.code) ?? Number.MAX_SAFE_INTEGER)
    );
  }
  if (sort_key === "name") {
    return list.sort((a, b) =>
      String(a.name || a.code || "").localeCompare(String(b.name || b.code || ""), "en", {
        sensitivity: "base",
      })
    );
  }
  if (sort_key === "siho") {
    return list.sort((a, b) => {
      const sa = sidebar_stock_siho_score(a);
      const sb = sidebar_stock_siho_score(b);
      if (sa == null && sb == null) return 0;
      if (sa == null) return 1;
      if (sb == null) return -1;
      return sb - sa;
    });
  }
  if (sort_key === "return_asc" || sort_key === "return_desc") {
    return list.sort((a, b) => {
      const ra = sidebar_stock_return_pct(a);
      const rb = sidebar_stock_return_pct(b);
      if (ra == null && rb == null) return 0;
      if (ra == null) return 1;
      if (rb == null) return -1;
      return sort_key === "return_desc" ? rb - ra : ra - rb;
    });
  }
  return list;
}

function sidebar_action_badge(stock) {
  const category = sidebar_stock_chip_category(stock);
  return {
    label: action_badge_label(stock),
    class_name: action_badge_class(stock.action),
    category,
  };
}

function sidebar_avatar_tone(stock) {
  const category = sidebar_stock_chip_category(stock);
  const code = String(stock?.code || stock?.name || "");
  const palette = ["tone_a", "tone_b", "tone_c", "tone_d", "tone_e"];
  const tone = palette[code.length % palette.length];
  return `${category} ${tone}`;
}

function count_stocks_for_sidebar_chip(stocks, chip_id) {
  return (stocks || []).filter((s) => matches_sidebar_chip_filter(s, chip_id)).length;
}

function build_action_steps(stock, filter_key) {
  const steps = [];
  const qa = stock?.quantity_advice || {};
  const cond = stock?.conditional_action;
  const plan = stock?.avg_down_plan;
  const staggered = stock?.staggered_cut_loss_plan;

  if (filter_key === "accumulate") {
    const buy_units = parseFloat(qa.approx_units);
    const has_buy = !Number.isNaN(buy_units) && buy_units > 0;
    if (has_buy) {
      const deploy_note =
        qa.approx_value != null ? `Deploy about ${fmt_inr(qa.approx_value)} at the current price.` : "";
      push_action_step(
        steps,
        `Add ${fmt_num(qa.approx_units)} units to your position`,
        [qa.rationale, deploy_note].filter(Boolean).join(" ")
      );
    } else {
      push_action_step(
        steps,
        "Avoid adding at current levels",
        qa.rationale || stock.summary || stock.expert_view
      );
    }
  } else if (filter_key === "average_down" && plan) {
    push_action_step(steps, "Average down now", plan.intro || qa.rationale);
    if (plan.step_2?.summary) {
      push_action_step(steps, "Phase 2 — Trim on recovery", plan.step_2.summary);
    }
  } else if (filter_key === "cut_loss" && staggered) {
    push_action_step(steps, "Staggered loss booking", staggered.intro || qa.rationale);
  } else if (filter_key === "hold") {
    push_action_step(steps, "Maintain current position", qa.rationale || stock.summary);
  } else if (filter_key === "profit_booking") {
    const sell_units = parseFloat(qa.approx_units);
    if (!Number.isNaN(sell_units) && sell_units > 0) {
      const proceeds_note =
        qa.approx_value != null
          ? `Target proceeds of about ${fmt_inr(qa.approx_value)}${qa.pct_of_holding != null ? ` (${qa.pct_of_holding}% of holding)` : ""}.`
          : "";
      push_action_step(
        steps,
        `Sell ${fmt_num(qa.approx_units)} units`,
        [qa.rationale, proceeds_note].filter(Boolean).join(" ")
      );
    } else {
      push_action_step(steps, "Book partial profit", qa.rationale || stock.summary);
    }
  } else if (filter_key === "exit") {
    const sell_units = parseFloat(qa.approx_units);
    const full_exit = qa.pct_of_holding != null && parseFloat(qa.pct_of_holding) >= 100;
    if (!Number.isNaN(sell_units) && sell_units > 0) {
      const proceeds_note =
        qa.approx_value != null ? `Expected proceeds about ${fmt_inr(qa.approx_value)}.` : "";
      push_action_step(
        steps,
        full_exit ? "Full exit — sell entire position" : `Exit ${fmt_num(qa.approx_units)} units`,
        [qa.rationale, proceeds_note].filter(Boolean).join(" ")
      );
    } else {
      push_action_step(
        steps,
        full_exit ? "Full exit" : "Exit position",
        qa.rationale || stock.summary
      );
    }
  } else if (filter_key === "cut_loss") {
    push_action_step(steps, "Cut loss / reduce exposure", qa.rationale || stock.summary);
  } else if (filter_key === "average_down") {
    push_action_step(steps, "Average down plan", qa.rationale || plan?.intro);
  }

  if (stock.expert_view) {
    const already_used = steps.some((s) =>
      (s.description || "").includes(stock.expert_view.slice(0, 48))
    );
    if (!already_used && steps.length < 4) {
      push_action_step(steps, "Expert view", stock.expert_view);
    }
  }

  if (cond?.rationale || cond?.description) {
    push_action_step(steps, "Conditional trigger", cond.rationale || cond.description);
  }

  if (qa.rationale && steps.length === 1) {
    const parts = qa.rationale
      .split(/(?<=[.!?])\s+/)
      .map((p) => p.trim())
      .filter((p) => p.length > 24);
    parts.slice(1, 3).forEach((part, idx) => {
      push_action_step(steps, `Additional guidance ${idx + 2}`, part);
    });
  }

  return steps.slice(0, 5);
}

function ActionPlanSubMetricsRow({ items }) {
  const visible = (items || []).filter((item) => item.value != null && item.value !== "");
  if (!visible.length) return null;

  return (
    <div className="portfolio_action_submetrics">
      {visible.map((item) => (
        <div key={item.label} className="portfolio_action_submetrics__item">
          <span className="portfolio_action_submetrics__lbl">{item.label}</span>
          <strong className={item.value_class || ""}>{item.value}</strong>
        </div>
      ))}
    </div>
  );
}

function ActionStepsSection({ steps }) {
  if (!steps?.length) return null;

  return (
    <section className="portfolio_action_steps">
      <h4 className="portfolio_action_steps__title">Action steps</h4>
      <ol className="portfolio_action_steps__list">
        {steps.map((step, idx) => (
          <li key={`${idx}-${step.title}`} className="portfolio_action_steps__card">
            <span className="portfolio_action_steps__num" aria-hidden="true">
              {idx + 1}
            </span>
            <div className="portfolio_action_steps__body">
              <strong className="portfolio_action_steps__headline">{step.title}</strong>
              {step.description && (
                <p className="portfolio_action_steps__desc">{step.description}</p>
              )}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

function build_submetrics_for_filter(filter_key, holding, quantity_advice) {
  const qa = quantity_advice || {};
  const base = [];

  if (holding?.qty != null) {
    base.push({ label: "Current qty", value: `${fmt_num(holding.qty)} units` });
  }
  if (holding?.avg_buy_price != null) {
    base.push({ label: "Avg buy price", value: fmt_price_inr(holding.avg_buy_price) });
  }
  if (holding?.current_price != null) {
    base.push({
      label: "Current price",
      value: fmt_price_inr(holding.current_price),
      value_class: "pos",
    });
  }

  if (filter_key === "accumulate") {
    if (qa.approx_units != null) {
      base.push({ label: "Units to add", value: fmt_num(qa.approx_units) });
    }
    if (qa.approx_value != null) {
      base.push({ label: "Capital to deploy", value: fmt_inr(qa.approx_value) });
    }
  }

  if (filter_key === "profit_booking") {
    if (qa.approx_units != null) {
      base.push({ label: "Units to sell", value: fmt_num(qa.approx_units) });
    }
    if (qa.pct_of_holding != null) {
      base.push({ label: "% of holding", value: `${qa.pct_of_holding}%` });
    }
    if (qa.approx_value != null) {
      base.push({ label: "Expected proceeds", value: fmt_inr(qa.approx_value) });
    }
    const total_qty = parseFloat(holding?.qty);
    const sell_qty = parseFloat(qa.approx_units);
    if (!Number.isNaN(total_qty) && !Number.isNaN(sell_qty)) {
      const remain = Math.max(0, total_qty - sell_qty);
      const curr_p = parseFloat(holding?.current_price);
      const remain_val =
        !Number.isNaN(curr_p) ? ` ≈ ${fmt_inr(remain * curr_p)}` : "";
      base.push({
        label: "Remaining position",
        value: `${fmt_num(remain)} units${remain_val}`,
      });
    }
    if (holding?.current_value != null && holding?.total_investment != null) {
      const pnl = holding.current_value - holding.total_investment;
      base.push({
        label: "Total unrealised P&L",
        value: fmt_inr(pnl, true),
        value_class: pct_class(pnl),
      });
    }
  }

  if (filter_key === "exit" || filter_key === "cut_loss") {
    if (qa.approx_units != null) {
      base.push({ label: "Units to sell", value: fmt_num(qa.approx_units) });
    }
    if (qa.pct_of_holding != null) {
      base.push({ label: "% of holding", value: `${qa.pct_of_holding}%` });
      if (filter_key === "exit" && parseFloat(qa.pct_of_holding) >= 100) {
        base.push({ label: "Exit type", value: "Full exit" });
      }
    }
    if (qa.approx_value != null) {
      base.push({ label: "Est. proceeds", value: fmt_inr(qa.approx_value) });
    }
  }

  if (filter_key === "hold") {
    if (holding?.current_value != null) {
      base.push({ label: "Position value", value: fmt_inr(holding.current_value) });
    }
    if (holding?.return_pct != null) {
      base.push({
        label: "Current return",
        value: fmt_pct(holding.return_pct),
        value_class: pct_class(holding.return_pct),
      });
    }
    if (holding?.alpha_pct != null) {
      base.push({
        label: "Alpha vs Nifty",
        value: fmt_pct(holding.alpha_pct),
        value_class: pct_class(holding.alpha_pct),
      });
    }
  }

  return base;
}

function BuyMorePanel({ stock, holding, quantity_advice }) {
  const filter_key = "accumulate";
  const steps = build_action_steps(stock, filter_key);
  const submetrics = build_submetrics_for_filter(filter_key, holding, quantity_advice);

  return (
    <div className="portfolio_action_execution_layout">
      <ActionPlanSubMetricsRow items={submetrics} />
      <ActionStepsSection steps={steps} />
    </div>
  );
}

function HoldExecutionHint() {
  return (
    <p className="portfolio_action_plan__muted portfolio_action_plan__hold_hint">
      No deployment or sale is scheduled for this holding.
    </p>
  );
}

function StockActionExecutionPanel({ stock, holding, quantity_advice }) {
  const filter_key = stock_filter_key(stock);
  const action_steps = build_action_steps(stock, filter_key);
  const submetrics = build_submetrics_for_filter(filter_key, holding, quantity_advice);
  const show_shared_layout = filter_key !== "accumulate";

  return (
    <>
      {filter_key === "accumulate" && (
        <BuyMorePanel stock={stock} holding={holding} quantity_advice={quantity_advice} />
      )}

      {show_shared_layout && (
        <div className="portfolio_action_execution_layout">
          <ActionPlanSubMetricsRow items={submetrics} />
          {filter_key === "hold" && <HoldExecutionHint />}
          <ActionStepsSection steps={action_steps} />
        </div>
      )}

      {filter_key === "average_down" && (
        <AvgDownPlanPanel stock={stock} holding={holding} quantity_advice={quantity_advice} />
      )}
    </>
  );
}

/** Cut loss / exit / book profit etc. — action item, phased plans, and steps in one tab. */
function StockExecutionStepPanel({ stock, holding, quantity_advice }) {
  const filter_key = stock_filter_key(stock);
  const action_steps = build_action_steps(stock, filter_key);
  const submetrics = build_submetrics_for_filter(filter_key, holding, quantity_advice);
  const show_action_item = filter_key !== "accumulate" && stock?.action_financials;
  const show_staggered =
    (filter_key === "cut_loss" || filter_key === "exit") &&
    !is_profit_position(stock) &&
    stock?.staggered_cut_loss_plan;
  const show_avg_down = filter_key === "average_down" && stock?.avg_down_plan;
  const show_steps = filter_key !== "accumulate";
  const has_content =
    show_action_item ||
    show_staggered ||
    show_avg_down ||
    filter_key === "accumulate" ||
    (show_steps && (action_steps.length > 0 || submetrics.some((m) => m.value != null)));

  if (!has_content) {
    return (
      <p className="portfolio_execution_step__empty">
        No execution steps are available for this stock yet.
      </p>
    );
  }

  return (
    <div className="portfolio_execution_step">
      {show_action_item && (
        <div className="portfolio_execution_step__section">
          <ActionItemCard stock={stock} />
        </div>
      )}

      {show_staggered && (
        <div className="portfolio_execution_step__section">
          <StaggeredCutLossPlanPanel stock={stock} holding={holding} />
        </div>
      )}

      {show_avg_down && (
        <div className="portfolio_execution_step__section">
          <AvgDownPlanPanel stock={stock} holding={holding} quantity_advice={quantity_advice} />
        </div>
      )}

      {filter_key === "accumulate" && (
        <div className="portfolio_execution_step__section">
          <BuyMorePanel stock={stock} holding={holding} quantity_advice={quantity_advice} />
        </div>
      )}

      {show_steps && (
        <div className="portfolio_execution_step__section portfolio_execution_step__section--steps">
          <h4 className="portfolio_execution_step__heading">Guided action steps</h4>
          <div className="portfolio_action_execution_layout">
            <ActionPlanSubMetricsRow items={submetrics} />
            {filter_key === "hold" && <HoldExecutionHint />}
            <ActionStepsSection steps={action_steps} />
          </div>
        </div>
      )}
    </div>
  );
}

const OUTLOOK_NARRATIVE_TITLES = {
  guidance: "Guidance narrative",
  capacity: "Capacity narrative",
  order_pipeline: "Order pipeline",
};

function NarrativeHighlightText({ text }) {
  const parts = useMemo(() => split_narrative_highlight_parts(text), [text]);
  if (!text) return null;
  return (
    <>
      {parts.map((part, idx) =>
        part.type === "metric" ? (
          <span key={idx} className="portfolio_narrative__metric">
            {part.value}
          </span>
        ) : (
          <span key={idx}>{part.value}</span>
        )
      )}
    </>
  );
}

function OutlookNarrativeBullet({ text }) {
  const { main, note } = useMemo(() => split_narrative_parenthetical(text), [text]);
  if (!main) return null;
  return (
    <li className="portfolio_narrative_card__item">
      <p className="portfolio_narrative_card__line">
        <NarrativeHighlightText text={main} />
      </p>
      {note && (
        <p className="portfolio_narrative_card__note">
          <NarrativeHighlightText text={note} />
        </p>
      )}
    </li>
  );
}

function OutlookNarrativeCard({ variant, text }) {
  const title = OUTLOOK_NARRATIVE_TITLES[variant] || OUTLOOK_NARRATIVE_TITLES.guidance;
  const { lead, bullets } = useMemo(() => parse_outlook_narrative(text), [text]);
  const clean_bullets = bullets.filter(Boolean);
  if (!clean_bullets.length) return null;

  return (
    <article className="portfolio_narrative_card">
      <h5 className="portfolio_narrative_card__title">{title}</h5>
      <div className="portfolio_narrative_card__body">
        {lead && (
          <p className="portfolio_narrative_card__topic">
            <NarrativeHighlightText text={lead} />
          </p>
        )}
        <ul className="portfolio_narrative_card__list">
          {clean_bullets.map((bullet, idx) => (
            <OutlookNarrativeBullet key={`${variant}-${idx}`} text={bullet} />
          ))}
        </ul>
      </div>
    </article>
  );
}

function FundamentalAnalysisContent({ stock }) {
  const f = stock?.fundamental || {};
  if (f.available === false) return null;
  const score = f.score != null ? f.score : f.composite_score;
  const has_data =
    score != null ||
    f.verdict ||
    f.pe != null ||
    f.peg != null ||
    (f.flags && f.flags.length);
  if (!has_data) return null;

  return (
    <>
      <AnalysisDetailRow label="Composite score" value={score != null ? `${Number(score).toFixed(2)} / 5` : "—"} />
      <AnalysisDetailRow label="Verdict" value={f.verdict || "—"} />
      <AnalysisDetailRow label="P/E" value={f.pe != null ? Number(f.pe).toFixed(2) : null} />
      <AnalysisDetailRow label="Industry P/E" value={f.industry_pe != null ? Number(f.industry_pe).toFixed(2) : null} />
      <AnalysisDetailRow
        label="P/E vs industry"
        value={f.pe_vs_industry != null ? `${Number(f.pe_vs_industry).toFixed(2)}x` : null}
      />
      <AnalysisDetailRow label="PEG" value={f.peg != null ? Number(f.peg).toFixed(2) : null} />
      <AnalysisDetailRow label="ROCE" value={f.roce != null ? `${Number(f.roce).toFixed(2)}%` : null} />
      <AnalysisDetailRow
        label="EPS CAGR (5y)"
        value={f.eps_cagr_5y_pct != null ? `${Number(f.eps_cagr_5y_pct).toFixed(2)}%` : null}
      />
      <AnalysisDetailRow label="Revenue rating (3y)" value={f.revenue_3 != null ? Number(f.revenue_3).toFixed(2) : null} />
      <AnalysisDetailRow label="Revenue rating (10y)" value={f.revenue_10 != null ? Number(f.revenue_10).toFixed(2) : null} />
      <AnalysisDetailRow label="Net profit (3y)" value={f.net_profit_3 != null ? Number(f.net_profit_3).toFixed(2) : null} />
      <AnalysisDetailRow label="Net profit (10y)" value={f.net_profit_10 != null ? Number(f.net_profit_10).toFixed(2) : null} />
      <AnalysisDetailRow label="Balance sheet" value={f.balance_sheet != null ? Number(f.balance_sheet).toFixed(2) : null} />
      <AnalysisDetailRow label="CFO growth" value={f.cfo_growth != null ? Number(f.cfo_growth).toFixed(2) : null} />
      <AnalysisDetailRow label="CFO to EBIT" value={f.cfo_to_ebit != null ? Number(f.cfo_to_ebit).toFixed(2) : null} />
    </>
  );
}

function FutureFundamentalContent({ stock }) {
  const fo = stock?.future_outlook || {};
  if (fo.available === false) return null;
  const scores = stock?.scores || {};
  const fs =
    fo.score != null
      ? fo.score
      : fo.composite_score != null
        ? fo.composite_score
        : scores.fundamental_future;

  const has_data =
    fs != null ||
    fo.verdict ||
    fo.guidance_rating != null ||
    fo.capacity_rating != null ||
    fo.guidance_text ||
    fo.capacity_text ||
    fo.order_pipeline_text;
  if (!has_data) return null;

  const has_narratives = !!(fo.guidance_text || fo.capacity_text || fo.order_pipeline_text);

  return (
    <div className="portfolio_future_outlook">
      <div className="portfolio_analysis_insight_card portfolio_future_outlook__scores">
        <AnalysisDetailRow
          label="Outlook score"
          value={fs != null ? `${Number(fs).toFixed(2)} / 5` : null}
          value_class="is_strong"
        />
        <AnalysisDetailRow label="Verdict" value={fo.verdict} />
        <AnalysisDetailRow
          label="Guidance"
          value={fo.guidance_rating != null ? `${Number(fo.guidance_rating).toFixed(2)} / 5` : null}
        />
        <AnalysisDetailRow
          label="Capacity"
          value={fo.capacity_rating != null ? `${Number(fo.capacity_rating).toFixed(2)} / 5` : null}
        />
        <AnalysisDetailRow
          label="Order book"
          value={fo.order_book_rating != null ? `${Number(fo.order_book_rating).toFixed(2)} / 5` : null}
        />
        {fo.latest_concall_date && (
          <AnalysisDetailRow label="Latest concall" value={fo.latest_concall_date} />
        )}
      </div>
      {has_narratives && (
        <div className="portfolio_narrative_grid">
          {fo.guidance_text && <OutlookNarrativeCard variant="guidance" text={fo.guidance_text} />}
          {fo.capacity_text && <OutlookNarrativeCard variant="capacity" text={fo.capacity_text} />}
          {fo.order_pipeline_text && (
            <OutlookNarrativeCard variant="order_pipeline" text={fo.order_pipeline_text} />
          )}
        </div>
      )}
    </div>
  );
}

function TechnicalAnalysisContent({ stock }) {
  const t = stock?.technical || {};
  if (t.available === false) return null;
  const ts = t.score != null ? t.score : t.composite_score;
  const mom = t.momentum || {};
  const vol = t.volume || {};
  const has_data = ts != null || t.trend || t.dma_signal;
  if (!has_data) return null;

  return (
    <>
      <AnalysisDetailRow label="Technical score" value={ts != null ? `${Number(ts).toFixed(2)} / 5` : "—"} />
      <AnalysisDetailRow label="Verdict" value={t.verdict} />
      <AnalysisDetailRow label="Trend" value={t.trend} />
      <AnalysisDetailRow label="Trend (1y)" value={t.trend_over_year} />
      <AnalysisDetailRow label="DMA signal" value={t.dma_signal} />
      {t.dma_50 != null && <AnalysisDetailRow label="DMA 50" value={fmt_price_inr(t.dma_50)} />}
      {t.dma_200 != null && <AnalysisDetailRow label="DMA 200" value={fmt_price_inr(t.dma_200)} />}
      <AnalysisDetailRow label="RSI" value={t.rsi != null ? Number(t.rsi).toFixed(2) : null} />
      <AnalysisDetailRow label="RSI zone" value={t.rsi_zone} />
      {mom["1m_pct"] != null && (
        <AnalysisDetailRow label="Return 1M" value={fmt_pct(mom["1m_pct"])} value_class={pct_class(mom["1m_pct"])} />
      )}
      {mom["3m_pct"] != null && (
        <AnalysisDetailRow label="Return 3M" value={fmt_pct(mom["3m_pct"])} value_class={pct_class(mom["3m_pct"])} />
      )}
      {mom["6m_pct"] != null && (
        <AnalysisDetailRow label="Return 6M" value={fmt_pct(mom["6m_pct"])} value_class={pct_class(mom["6m_pct"])} />
      )}
      {mom.composite_pct != null && (
        <AnalysisDetailRow
          label="Momentum composite"
          value={fmt_pct(mom.composite_pct)}
          value_class={pct_class(mom.composite_pct)}
        />
      )}
      {vol.vmd_30 != null && (
        <AnalysisDetailRow
          label="VMD-30"
          value={`${Number(vol.vmd_30).toFixed(2)}x${vol.vmd_30_label ? ` (${vol.vmd_30_label})` : ""}`}
        />
      )}
      {vol.vmd_365 != null && (
        <AnalysisDetailRow
          label="VMD-365"
          value={`${Number(vol.vmd_365).toFixed(2)}x${vol.vmd_365_label ? ` (${vol.vmd_365_label})` : ""}`}
        />
      )}
    </>
  );
}

function RiskVolatilityContent({ stock }) {
  const r = stock?.risk || {};
  if (!r) return null;
  const vol = r.volatility_annual_pct != null ? r.volatility_annual_pct : r.volatility_pct;
  const beta = r.beta_vs_nifty != null ? r.beta_vs_nifty : r.beta;
  const dd = r.max_drawdown_from_52w_high_pct != null ? r.max_drawdown_from_52w_high_pct : r.max_drawdown_pct;
  const has_data =
    r.risk_tier != null || vol != null || beta != null || dd != null || r.classification || r.risk_assessment;
  if (!has_data) return null;

  const tier_labels = ["", "High", "Moderate", "Lower"];

  return (
    <>
      <AnalysisDetailRow label="Assessment" value={r.risk_assessment} />
      <AnalysisDetailRow label="Classification" value={r.classification} />
      {r.risk_tier != null && (
        <AnalysisDetailRow
          label="Risk tier"
          value={`Tier ${r.risk_tier} — ${tier_labels[r.risk_tier] || ""}`}
        />
      )}
      <AnalysisDetailRow label="Volatility (annual)" value={vol != null ? `${Number(vol).toFixed(2)}%` : null} />
      <AnalysisDetailRow label="Beta vs Nifty" value={beta != null ? Number(beta).toFixed(2) : null} />
      <AnalysisDetailRow
        label="Max drawdown (52w high)"
        value={dd != null ? `${Number(dd).toFixed(2)}%` : null}
      />
      {r.dist_from_52w_low_pct != null && (
        <AnalysisDetailRow
          label="Dist. from 52w low"
          value={`${Number(r.dist_from_52w_low_pct).toFixed(2)}%`}
        />
      )}
    </>
  );
}

function SupportResistanceContent({ stock }) {
  const sr = stock?.support_resistance || {};
  if (!sr) return null;
  const has_data =
    sr.signal ||
    sr.nearest_support != null ||
    sr.nearest_resistance != null ||
    sr.detail;
  if (!has_data) return null;

  const pvn = stock?.holding?.period_vs_nifty;

  return (
    <>
      <AnalysisDetailRow label="Signal" value={sr.signal} />
      <AnalysisDetailRow
        label="Nearest support"
        value={sr.nearest_support != null ? fmt_price_inr(sr.nearest_support) : null}
      />
      <AnalysisDetailRow
        label="Nearest resistance"
        value={sr.nearest_resistance != null ? fmt_price_inr(sr.nearest_resistance) : null}
      />
      <AnalysisDetailRow
        label="Range position"
        value={sr.range_position_pct != null ? `${Number(sr.range_position_pct).toFixed(2)}%` : null}
      />
      <AnalysisDetailRow label="Zone" value={sr.zone} />
      <AnalysisDetailRow label="Volume trend" value={sr.volume_trend} />
      <AnalysisDetailRow label="Trajectory" value={sr.trajectory || sr.price_trajectory} />
      {sr.risk_reward_ratio != null && (
        <AnalysisDetailRow label="Risk / reward" value={Number(sr.risk_reward_ratio).toFixed(2)} />
      )}
      {sr.detail && <p className="portfolio_analysis_note">{sr.detail}</p>}
      {pvn && typeof pvn === "object" && Object.keys(pvn).length > 0 && (
        <div className="portfolio_analysis_sr_table_wrap">
          <h5>Returns vs Nifty</h5>
          <table className="portfolio_analysis_sr_table">
            <thead>
              <tr>
                {Object.keys(pvn).map((period) => (
                  <th key={period}>{period}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {Object.keys(pvn).map((period) => (
                  <td key={`s-${period}`} className={pct_class(pvn[period]?.stock)}>
                    {fmt_pct(pvn[period]?.stock)}
                  </td>
                ))}
              </tr>
              <tr>
                {Object.keys(pvn).map((period) => (
                  <td key={`n-${period}`} className="portfolio_analysis_muted">
                    {fmt_pct(pvn[period]?.nifty)}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

function format_peer_name(name) {
  return String(name || "")
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function fmt_peer_mcap_cr(mcap_cr) {
  const v = parseFloat(mcap_cr);
  if (Number.isNaN(v) || v <= 0) return null;
  if (v >= 1000) {
    return `₹${(v / 1000).toFixed(1)}k Cr`;
  }
  return `₹${Math.round(v).toLocaleString("en-IN")} Cr`;
}

function PeerScoreChip({ label, value }) {
  const n = parseFloat(value);
  const tone = siho_score_tone(value);
  return (
    <div className={`portfolio_peer_chip ${tone}`}>
      <span className="portfolio_peer_chip__lbl">{label}</span>
      <strong>{Number.isNaN(n) ? "—" : n.toFixed(1)}</strong>
    </div>
  );
}

function IndustryPeerCard({ peer }) {
  const combined = peer?.combined_score;
  const tone = siho_score_tone(combined);
  const mcap_label = fmt_peer_mcap_cr(peer?.mcap_cr);

  return (
    <article className="portfolio_peer_card">
      <div className="portfolio_peer_card__head">
        <div className="portfolio_peer_card__identity">
          <span className="portfolio_peer_card__code">{peer.code}</span>
          {peer.name && <span className="portfolio_peer_card__name">{format_peer_name(peer.name)}</span>}
        </div>
        {combined != null && (
          <div className={`portfolio_peer_card__score ${tone}`}>
            <span className="portfolio_peer_card__score_lbl">SIHO</span>
            <div className="portfolio_peer_card__score_val">
              <strong>{Number(combined).toFixed(2)}</strong>
              <small>/ 5</small>
            </div>
          </div>
        )}
      </div>
      {mcap_label && <div className="portfolio_peer_card__mcap">{mcap_label}</div>}
      <div className="portfolio_peer_card__breakdown">
        <PeerScoreChip label="Fundamental" value={peer.fundamental_score} />
        <PeerScoreChip label="Future" value={peer.future_score} />
        <PeerScoreChip label="Technical" value={peer.technical_score} />
      </div>
    </article>
  );
}

function IndustryPeersContent({ stock, portfolio_stocks = [] }) {
  const [peers, set_peers] = useState(null);
  const [loading, set_loading] = useState(false);
  const [error, set_error] = useState(null);
  const industry = stock?.industry_group;

  useEffect(() => {
    if (!industry) return;
    set_loading(true);
    set_error(null);
    fetch(
      `/api/portfolio_analyzer/industry_analysis?industry_group=${encodeURIComponent(industry)}`
    )
      .then((r) => r.json())
      .then((d) => {
        if (d?.error) {
          set_error(d.error);
          set_peers(null);
        } else {
          set_peers(d);
          set_error(null);
        }
        set_loading(false);
      })
      .catch(() => {
        set_error("Failed to load peers.");
        set_loading(false);
      });
  }, [industry, stock?.code]);

  if (!industry) {
    return <p className="portfolio_analysis_note">No industry group for this stock.</p>;
  }
  if (loading) return <p className="portfolio_analysis_note">Loading industry peers…</p>;
  if (error) return <p className="portfolio_analysis_note neg">{error}</p>;

  const list = filter_industry_peers_outside_portfolio(peers?.top_peers, portfolio_stocks);

  if (!list.length) {
    return (
      <p className="portfolio_analysis_note">No peers outside your portfolio found.</p>
    );
  }

  return (
    <div className="portfolio_peers_panel">
      <p className="portfolio_peers_panel__industry">{industry}</p>
      <div className="portfolio_peers_grid">
        {list.map((p) => (
          <IndustryPeerCard key={p.code} peer={p} />
        ))}
      </div>
    </div>
  );
}

function stock_has_fundamental_data(stock) {
  const f = stock?.fundamental || {};
  if (f.available === false) return false;
  const score = f.score != null ? f.score : f.composite_score;
  return !!(score != null || f.verdict || f.pe != null || f.peg != null || (f.flags && f.flags.length));
}

function stock_has_future_data(stock) {
  const fo = stock?.future_outlook || {};
  if (fo.available === false) return false;
  const fs = fo.score != null ? fo.score : fo.composite_score;
  return !!(
    fs != null ||
    fo.verdict ||
    fo.guidance_rating != null ||
    fo.guidance_text ||
    fo.capacity_text
  );
}

function stock_has_technical_data(stock) {
  const t = stock?.technical || {};
  if (t.available === false) return false;
  const ts = t.score != null ? t.score : t.composite_score;
  return !!(ts != null || t.trend || t.dma_signal);
}

function stock_has_risk_data(stock) {
  const r = stock?.risk || {};
  return !!(
    r.risk_tier != null ||
    r.volatility_annual_pct != null ||
    r.beta_vs_nifty != null ||
    r.classification ||
    r.risk_assessment
  );
}

function stock_has_sr_data(stock) {
  const sr = stock?.support_resistance || {};
  return !!(sr.signal || sr.nearest_support != null || sr.nearest_resistance != null || sr.detail);
}

function StockDeepDiveSections({ stock, portfolio_stocks = [] }) {
  const has_fund = stock_has_fundamental_data(stock);
  const has_future = stock_has_future_data(stock);
  const has_tech = stock_has_technical_data(stock);
  const has_risk = stock_has_risk_data(stock);
  const has_sr = stock_has_sr_data(stock);
  const has_peers = !!stock?.industry_group;

  if (!has_fund && !has_future && !has_tech && !has_risk && !has_sr && !has_peers) {
    return (
      <div className="portfolio_analysis_stack">
        <p className="portfolio_analysis_note">Detailed analysis is not available for this stock.</p>
      </div>
    );
  }

  return (
    <div className="portfolio_analysis_stack">
      <h4 className="portfolio_analysis_stack__title">
        <span className="portfolio_analysis_stack__icon" aria-hidden="true">
          🔎
        </span>
        Stock deep dive
      </h4>
      <AnalysisSection icon="📋" title="Fundamental analysis" is_empty={!has_fund}>
        <FundamentalAnalysisContent stock={stock} />
      </AnalysisSection>
      <AnalysisSection icon="🔭" title="Future fundamental" is_empty={!has_future}>
        <FutureFundamentalContent stock={stock} />
      </AnalysisSection>
      <AnalysisSection icon="📉" title="Technical analysis" is_empty={!has_tech}>
        <TechnicalAnalysisContent stock={stock} />
      </AnalysisSection>
      <AnalysisSection icon="⚠️" title="Risk & volatility" is_empty={!has_risk}>
        <RiskVolatilityContent stock={stock} />
      </AnalysisSection>
      <AnalysisSection icon="📍" title="Support & resistance" is_empty={!has_sr}>
        <SupportResistanceContent stock={stock} />
      </AnalysisSection>
      <AnalysisSection icon="🔍" title="Industry peers" is_empty={!has_peers}>
        <IndustryPeersContent stock={stock} portfolio_stocks={portfolio_stocks} />
      </AnalysisSection>
    </div>
  );
}

const PRINT_ACTION_SECTIONS = [
  { label: "Buy more (Accumulate)", aws_key: null, count_key: "accumulate" },
  { label: "Average down", aws_key: "average_down", count_key: null },
  { label: "Buy more", aws_key: "average_up", count_key: null },
  { label: "Cut loss", aws_key: "cut_loss", count_key: null },
  { label: "Book profit", aws_key: "profit_booking", count_key: null },
  { label: "Exit", aws_key: "exit", count_key: null },
  { label: "Hold", aws_key: null, count_key: "hold" },
];

function PrintHoldingsSihoScore({ stock }) {
  const score = sidebar_stock_siho_score(stock);
  if (score == null) {
    return <span className="portfolio_print__holdings_score_muted">—</span>;
  }
  return (
    <span className="portfolio_print__holdings_score">
      <strong>{score.toFixed(2)}</strong>
      <span className="portfolio_print__holdings_score_suffix"> / 5</span>
    </span>
  );
}

function PrintMetricGrid({ items }) {
  const rows = items.filter((item) => item.value != null && item.value !== "");
  if (!rows.length) return null;
  return (
    <div className="portfolio_print__metric_grid">
      {rows.map((item) => (
        <div key={item.label} className="portfolio_print__metric">
          <span className="portfolio_print__metric_lbl">{item.label}</span>
          <span className={`portfolio_print__metric_val${item.tone ? ` is_${item.tone}` : ""}`}>
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
}

function PortfolioPrintReport({ data, filter_counts }) {
  const port = data?.portfolio || {};
  const aws = data?.action_wise_summary || {};
  const action_summary = data?.action_summary || {};
  const tpp = data?.three_phase_portfolio;
  const stock_count = data?.count ?? data?.stocks?.length ?? 0;
  const counts = filter_counts || {};
  const generated_at = new Date().toLocaleString("en-IN", {
    dateStyle: "long",
    timeStyle: "short",
  });

  const return_abs =
    port.total_invested != null && port.current_value != null
      ? port.current_value - port.total_invested
      : null;

  const plan_loss = plan_loss_amount(data);

  const print_stocks = [...(data?.stocks || [])].sort((a, b) =>
    String(a.name || a.code || "").localeCompare(String(b.name || b.code || ""), "en", {
      sensitivity: "base",
    })
  );
  const action_table_rows = PRINT_ACTION_SECTIONS.map(({ label, aws_key, count_key }) => {
    let block = aws_key ? aws[aws_key] : null;
    if (aws_key === "average_up") {
      block = resolve_buy_more_wise_block(aws, print_stocks, action_summary);
    }
    const n = count_key ? counts[count_key] ?? 0 : block?.stock_count ?? 0;
    const metrics = [];
    if (block?.capital_required != null && block.capital_required > 0) {
      metrics.push(`Capital ${fmt_inr(block.capital_required)}`);
    }
    if (block?.net_proceeds != null) metrics.push(`Proceeds ${fmt_inr(block.net_proceeds)}`);
    if (block?.net_loss != null) metrics.push(`Loss ${fmt_inr(block.net_loss)}`);
    if (block?.profit_booked != null) metrics.push(`Profit ${fmt_inr(block.profit_booked)}`);
    if (block?.net_loss_saved != null) metrics.push(`Loss saved ${fmt_inr(block.net_loss_saved)}`);
    if (block?.net_pnl != null) metrics.push(`Net P&L ${fmt_inr(block.net_pnl, true)}`);
    if (block?.current_total_loss != null) {
      metrics.push(`Total position loss ${fmt_inr(block.current_total_loss)}`);
    }
    return [label, String(n), metrics.length ? metrics.join(" · ") : "—"];
  });

  const p1 = tpp?.phase_1 || {};
  const p2 = tpp?.phase_2 || {};
  const p3 = tpp?.phase_3 || {};
  const ft = tpp?.footer || {};

  return (
    <div className="portfolio_print_report">
      <header className="portfolio_print__header">
        <img src={logo} alt="InvestVidhi" className="portfolio_print__logo" />
        <h1 className="portfolio_print__title">Portfolio Analysis Report</h1>
        <p className="portfolio_print__meta">Powered by SIHO Research</p>
        <p className="portfolio_print__date">Generated {generated_at}</p>
      </header>

      <section className="portfolio_print__section">
        <h2 className="portfolio_print__section_title">Portfolio overview</h2>
        <PrintMetricGrid
          items={[
            { label: "Total stocks", value: String(stock_count) },
            { label: "Portfolio stance", value: port.action || "—" },
            { label: "Total invested", value: fmt_inr(port.total_invested) },
            { label: "Market value", value: fmt_inr(port.current_value) },
            {
              label: "Total return",
              value: port.return_pct != null ? fmt_pct(port.return_pct) : "—",
              tone: pct_class(port.return_pct) || undefined,
            },
            {
              label: "Return (absolute)",
              value: return_abs != null ? fmt_inr(return_abs, true) : "—",
              tone: pct_class(return_abs) || undefined,
            },
            {
              label: "Alpha vs Nifty",
              value: port.alpha_pct != null ? fmt_pct(port.alpha_pct) : "—",
              tone: pct_class(port.alpha_pct) || undefined,
            },
            {
              label: "CAGR",
              value: port.cagr_pct != null ? fmt_pct(port.cagr_pct) : "—",
              tone: pct_class(port.cagr_pct) || undefined,
            },
            { label: "Avg holding period", value: port.holding_period || "—" },
            { label: "Sectors", value: String(port.concentration?.distinct_sectors ?? "—") },
            { label: "SIHO portfolio score", value: port.action_score != null ? `${Number(port.action_score).toFixed(2)} / 5` : "—" },
            { label: "Plan loss (3-phase modeled)", value: fmt_inr(plan_loss) },
          ]}
        />
        {port.action_explanation && (
          <p className="portfolio_print__summary">{format_portfolio_summary(port.action_explanation)}</p>
        )}
      </section>

      {print_stocks.length > 0 && (
        <section className="portfolio_print__section portfolio_print__section--holdings">
          <h2 className="portfolio_print__holdings_title">Holdings</h2>
          <table className="portfolio_print__holdings_table">
            <thead>
              <tr>
                <th scope="col">Stock name</th>
                <th scope="col">Action</th>
                <th scope="col" className="portfolio_print__holdings_th_score">
                  SIHO score
                </th>
              </tr>
            </thead>
            <tbody>
              {print_stocks.map((stock) => (
                <tr key={stock.code || stock.name}>
                  <td className="portfolio_print__holdings_name">
                    {stock.name || stock.code || "—"}
                  </td>
                  <td className="portfolio_print__holdings_action">{action_badge_label(stock)}</td>
                  <td className="portfolio_print__holdings_score_cell">
                    <PrintHoldingsSihoScore stock={stock} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}

      <section className="portfolio_print__section">
        <h2 className="portfolio_print__section_title">Action-wise summary</h2>
        <table className="portfolio_print__table">
          <thead>
            <tr>
              <th>Action</th>
              <th>Stocks</th>
              <th>Key figures</th>
            </tr>
          </thead>
          <tbody>
            {action_table_rows.map(([action, n, detail]) => (
              <tr key={action}>
                <td>{action}</td>
                <td className="portfolio_print__num">{n}</td>
                <td>{detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {action_summary && Object.keys(action_summary).length > 0 && (
          <>
            <h3 className="portfolio_print__subsection_title">Net impact (all actions combined)</h3>
            <PrintMetricGrid
              items={[
                { label: "Net proceeds", value: fmt_inr(action_summary.net_proceeds) },
                { label: "Profit booked", value: fmt_inr(action_summary.net_profit_booked), tone: "pos" },
                { label: "Loss booked", value: fmt_inr(action_summary.net_loss_booked), tone: "neg" },
                { label: "Avg-up capital", value: fmt_inr(action_summary.net_avg_up_capital), tone: "theme" },
                { label: "Stocks — avg up", value: String(action_summary.stocks_avg_up_count ?? "—") },
                { label: "Stocks — cut loss", value: String(action_summary.stocks_cut_loss_count ?? "—") },
                { label: "Stocks — book profit", value: String(action_summary.stocks_profit_booking_count ?? "—") },
                {
                  label: "New invested (modeled)",
                  value: fmt_inr(action_summary.portfolio_new_invested),
                },
                {
                  label: "New market value (modeled)",
                  value: fmt_inr(action_summary.portfolio_new_market_value),
                },
              ]}
            />
          </>
        )}
      </section>

      {tpp && (
        <section className="portfolio_print__section">
          <h2 className="portfolio_print__section_title">Three-phase execution plan</h2>
          <p className="portfolio_print__note">
            Phase 1 covers immediate actions (sales, trims, buy-more and average-down buy capital).
            Phases 2–3 model later recovery sells (cut-loss tranches and average-down exit legs).
          </p>
          <div className="portfolio_print__phase_grid">
            <div className="portfolio_print__phase_card">
              <h3 className="portfolio_print__phase_name">Phase 1 — now</h3>
              <ul className="portfolio_print__list">
                <li>Proceeds from sales: {fmt_inr(p1.proceeds_from_sales)}</li>
                <li>Profit booked: <SignedInrValue value={p1.profit_booked} mode="pos" /></li>
                <li>Loss booked: <SignedInrValue value={p1.loss_booked} mode="neg" /></li>
                <li>Net P&L booked: {fmt_inr(p1.net_pnl_booked)}</li>
                <li>Capital to buy more: {fmt_inr(p1.avg_up_capital)}</li>
                <li>Capital to average down: {fmt_inr(p1.avg_down_capital)}</li>
              </ul>
            </div>
            <div className="portfolio_print__phase_card">
              <h3 className="portfolio_print__phase_name">Phase 2 — recovery / stagger</h3>
              <ul className="portfolio_print__list">
                <li>Proceeds from sales (modeled): {fmt_inr(p2.proceeds_from_sales)}</li>
                <li>Loss booked (modeled): <SignedInrValue value={p2.loss_booked} mode="neg" /></li>
              </ul>
            </div>
            <div className="portfolio_print__phase_card">
              <h3 className="portfolio_print__phase_name">Phase 3 — recovery / stagger</h3>
              <ul className="portfolio_print__list">
                <li>Proceeds from sales (modeled): {fmt_inr(p3.proceeds_from_sales)}</li>
                <li>Loss booked (modeled): <SignedInrValue value={p3.loss_booked} mode="neg" /></li>
              </ul>
            </div>
          </div>
          <div className="portfolio_print__footer_box">
            <h3 className="portfolio_print__subsection_title">If all three phases are followed (modeled)</h3>
            <PrintMetricGrid
              items={[
                {
                  label: "Cumulative loss booked (all phases)",
                  value: fmt_inr(ft.cumulative_loss_booked_all_phases),
                  tone: "neg",
                },
                {
                  label: "Estimated residual unrealized loss",
                  value: fmt_inr(ft.estimated_residual_unrealized_loss),
                  tone: "neg",
                },
              ]}
            />
          </div>
        </section>
      )}

      <footer className="portfolio_print__foot">
        <p>Confidential — for the account holder&apos;s use only. Figures are model outputs from SIHO Research analytics.</p>
      </footer>
    </div>
  );
}

const ACTION_PILLS_VISIBLE_COUNT = 7;

function SignedInrValue({ value, mode = "plain" }) {
  const v = parseFloat(value);
  if (Number.isNaN(v)) return <>—</>;
  if (mode === "pos") {
    return (
      <span className={v >= 0 ? "pos" : "neg"}>
        {v >= 0 ? "+" : "-"}
        {fmt_inr(Math.abs(v))}
      </span>
    );
  }
  if (mode === "neg") {
    return <span className="neg">-{fmt_inr(Math.abs(v))}</span>;
  }
  return <>{fmt_inr(v)}</>;
}

function ThreePhaseCmpRow({
  label,
  value,
  baseline_amt,
  pct_field,
  baseline_name,
  hide_baseline = false,
}) {
  const pct =
    pct_field != null && pct_field !== "" && !Number.isNaN(parseFloat(pct_field))
      ? parseFloat(pct_field)
      : null;
  const has_baseline = baseline_amt != null && baseline_amt !== "";

  return (
    <div className="portfolio_tph__metric">
      <div className="portfolio_tph__metric_main">
        <span className="portfolio_tph__metric_lbl">{label}</span>
        <span className="portfolio_tph__metric_val">
          {value}
          {hide_baseline && pct != null && (
            <span className="portfolio_tph__metric_badge">{pct}% of baseline</span>
          )}
        </span>
      </div>
      {!hide_baseline && has_baseline && (
        <p className="portfolio_tph__metric_ctx">
          vs total {baseline_name} <strong>{fmt_inr(baseline_amt)}</strong>
          {pct != null && <span className="portfolio_tph__pct"> · {pct}% of baseline</span>}
        </p>
      )}
    </div>
  );
}

function ThreePhaseBaselineSummary({ rows }) {
  const items = (rows || []).filter((row) => row.baseline_amt != null && row.baseline_amt !== "");
  if (!items.length) return null;

  return (
    <details className="portfolio_tph__baseline_details">
      <summary>Compare to portfolio baseline</summary>
      <ul className="portfolio_tph__baseline_list">
        {items.map((row) => {
          const pct =
            row.pct_field != null &&
            row.pct_field !== "" &&
            !Number.isNaN(parseFloat(row.pct_field))
              ? parseFloat(row.pct_field)
              : null;
          return (
            <li key={row.label}>
              <span>{row.label}</span>
              <span>
                {pct != null && <strong>{pct}%</strong>}
                {pct != null ? " of " : ""}
                total {row.baseline_name} ({fmt_inr(row.baseline_amt)})
              </span>
            </li>
          );
        })}
      </ul>
    </details>
  );
}

function ThreePhasePortfolioPanel({ three_phase_portfolio, className = "" }) {
  if (!three_phase_portfolio) return null;

  const bl = three_phase_portfolio.baseline || {};
  const p1 = three_phase_portfolio.phase_1 || {};
  const p2 = three_phase_portfolio.phase_2 || {};
  const p3 = three_phase_portfolio.phase_3 || {};
  const ft = three_phase_portfolio.footer || {};

  const cum_loss = ft.cumulative_loss_booked_all_phases;
  const res_loss = ft.estimated_residual_unrealized_loss;
  let peek = "Tap to expand";
  if (cum_loss != null && !Number.isNaN(parseFloat(cum_loss))) {
    peek = `Cum. loss ${fmt_inr(cum_loss)}`;
  }
  if (res_loss != null && !Number.isNaN(parseFloat(res_loss))) {
    peek = peek === "Tap to expand" ? `Residual ${fmt_inr(res_loss)}` : `${peek} · Residual ${fmt_inr(res_loss)}`;
  }

  const net_booked = p1.net_pnl_booked;
  const net_cls =
    net_booked != null && parseFloat(net_booked) > 0
      ? "pos"
      : net_booked != null && parseFloat(net_booked) < 0
        ? "neg"
        : "";

  const ad_cap = p1.avg_down_capital;

  const is_page = className.includes("portfolio_tph--page");
  const root_class = ["portfolio_tph", className].filter(Boolean).join(" ");

  const phase_1_baseline_rows = [
    {
      label: "Profit booked",
      baseline_amt: bl.total_unrealized_profit,
      pct_field: p1.profit_booked_pct_of_unrealized_profit,
      baseline_name: "unrealized profit",
    },
    {
      label: "Loss booked",
      baseline_amt: bl.total_unrealized_loss,
      pct_field: p1.loss_booked_pct_of_unrealized_loss,
      baseline_name: "unrealized loss",
    },
    {
      label: "Net P&L booked",
      baseline_amt: bl.net_unrealized_pnl,
      pct_field: p1.net_pnl_booked_pct_of_net_unrealized_pnl,
      baseline_name: "unrealized net P&L",
    },
  ];

  return (
    <section className={root_class}>
      <header className="portfolio_tph__head">
        <div className="portfolio_tph__head_text">
          <h3 className="portfolio_tph__title">Three-phase execution plan</h3>
          {is_page && (
            <p className="portfolio_tph__head_sub">
              Phase 1 = actions now · Phases 2–3 = modeled later sells only
            </p>
          )}
        </div>
        {peek !== "Tap to expand" && (
          <p className="portfolio_tph__head_stats">{peek}</p>
        )}
      </header>
      <div className="portfolio_tph__inner">
          {!is_page && (
            <p className="portfolio_tph__note">
              Phase 1 is everything you do now (sales, trims, full exits, buy-more and average-down{" "}
              <strong>buy</strong> capital). Phases 2–3 are modeled <strong>later sells</strong> only
              (cut-loss tranches 2–3 and average-down exit legs).
            </p>
          )}
          {is_page && (
            <details className="portfolio_tph__intro_details">
              <summary>What each phase means</summary>
              <p className="portfolio_tph__note">
                <strong>Phase 1</strong> covers immediate actions: sales, trims, exits, buy-more, and
                average-down capital. <strong>Phases 2–3</strong> model later cut-loss tranches and
                average-down exit legs only.
              </p>
            </details>
          )}
          <div className="portfolio_tph__phase_grid">
            <div className="portfolio_tph__phase_card portfolio_tph__phase_card--now">
              <div className="portfolio_tph__phase_title">Phase 1 — now</div>

              <div className="portfolio_tph__phase_group">
                <div className="portfolio_tph__phase_group_title">Sales</div>
                <div className="portfolio_tph__metric">
                  <div className="portfolio_tph__metric_main">
                    <span className="portfolio_tph__metric_lbl">Proceeds from sales</span>
                    <span className="portfolio_tph__metric_val">{fmt_inr(p1.proceeds_from_sales)}</span>
                  </div>
                </div>
              </div>

              <div className="portfolio_tph__phase_group">
                <div className="portfolio_tph__phase_group_title">Booked P&amp;L</div>
                <ThreePhaseCmpRow
                  hide_baseline={is_page}
                  label="Profit booked"
                  value={<SignedInrValue value={p1.profit_booked} mode="pos" />}
                  baseline_amt={bl.total_unrealized_profit}
                  pct_field={p1.profit_booked_pct_of_unrealized_profit}
                  baseline_name="unrealized profit"
                />
                <ThreePhaseCmpRow
                  hide_baseline={is_page}
                  label="Loss booked"
                  value={<SignedInrValue value={p1.loss_booked} mode="neg" />}
                  baseline_amt={bl.total_unrealized_loss}
                  pct_field={p1.loss_booked_pct_of_unrealized_loss}
                  baseline_name="unrealized loss"
                />
                <ThreePhaseCmpRow
                  hide_baseline={is_page}
                  label="Net P&L booked"
                  value={
                    net_booked == null || net_booked === "" ? (
                      "—"
                    ) : (
                      <span className={net_cls}>
                        {parseFloat(net_booked) >= 0 ? "+" : "-"}
                        {fmt_inr(Math.abs(parseFloat(net_booked)))}
                      </span>
                    )
                  }
                  baseline_amt={bl.net_unrealized_pnl}
                  pct_field={p1.net_pnl_booked_pct_of_net_unrealized_pnl}
                  baseline_name="unrealized net P&L"
                />
              </div>

              <div className="portfolio_tph__phase_group">
                <div className="portfolio_tph__phase_group_title">Deploy capital</div>
                <div className="portfolio_tph__metric">
                  <div className="portfolio_tph__metric_main">
                    <span className="portfolio_tph__metric_lbl">Capital to buy more</span>
                    <span className="portfolio_tph__metric_val">{fmt_inr(p1.avg_up_capital)}</span>
                  </div>
                </div>
                <div className="portfolio_tph__metric">
                  <div className="portfolio_tph__metric_main">
                    <span className="portfolio_tph__metric_lbl">Capital to average down</span>
                    <span className="portfolio_tph__metric_val">{fmt_inr(ad_cap)}</span>
                  </div>
                </div>
              </div>

              {is_page && <ThreePhaseBaselineSummary rows={phase_1_baseline_rows} />}
            </div>

            <div className="portfolio_tph__phase_card">
              <div className="portfolio_tph__phase_title">Phase 2 — recovery</div>
              <p className="portfolio_tph__phase_note">
                Cut-loss tranche 2 + first average-down sell leg.
              </p>
              <div className="portfolio_tph__metric">
                <div className="portfolio_tph__metric_main">
                  <span className="portfolio_tph__metric_lbl">Proceeds (modeled)</span>
                  <span className="portfolio_tph__metric_val">{fmt_inr(p2.proceeds_from_sales)}</span>
                </div>
              </div>
              <div className="portfolio_tph__metric">
                <div className="portfolio_tph__metric_main">
                  <span className="portfolio_tph__metric_lbl">Loss booked (modeled)</span>
                  <span className="portfolio_tph__metric_val">
                    <SignedInrValue value={p2.loss_booked} mode="neg" />
                  </span>
                </div>
              </div>
            </div>

            <div className="portfolio_tph__phase_card">
              <div className="portfolio_tph__phase_title">Phase 3 — recovery</div>
              <p className="portfolio_tph__phase_note">
                Cut-loss tranche 3 + remaining average-down sell legs.
              </p>
              <div className="portfolio_tph__metric">
                <div className="portfolio_tph__metric_main">
                  <span className="portfolio_tph__metric_lbl">Proceeds (modeled)</span>
                  <span className="portfolio_tph__metric_val">{fmt_inr(p3.proceeds_from_sales)}</span>
                </div>
              </div>
              <div className="portfolio_tph__metric">
                <div className="portfolio_tph__metric_main">
                  <span className="portfolio_tph__metric_lbl">Loss booked (modeled)</span>
                  <span className="portfolio_tph__metric_val">
                    <SignedInrValue value={p3.loss_booked} mode="neg" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="portfolio_tph__footer">
            <div className="portfolio_tph__footer_heading">If you follow all three phases (modeled)</div>
            <div className="portfolio_tph__footer_row">
              <span className="portfolio_tph__footer_lbl">Cumulative loss booked (all phases)</span>
              <span className="portfolio_tph__footer_val neg">
                {fmt_inr(ft.cumulative_loss_booked_all_phases)}
              </span>
            </div>
            <div className="portfolio_tph__footer_row">
              <span className="portfolio_tph__footer_lbl">
                Estimated residual unrealized loss (portfolio)
              </span>
              <span className="portfolio_tph__footer_val neg">
                {fmt_inr(ft.estimated_residual_unrealized_loss)}
              </span>
            </div>
          </div>
        </div>
    </section>
  );
}

function accumulate_section_totals(stocks, action_wise, action_summary) {
  const aws_up = action_wise?.average_up || {};
  let capital = aws_up.capital_required;
  if (capital == null || Number(capital) === 0) {
    capital = action_summary?.net_avg_up_capital;
  }
  if (capital == null || Number(capital) === 0) {
    const summed = (stocks || []).reduce((sum, s) => {
      const v =
        parseFloat(s.action_financials?.capital_required) ||
        parseFloat(s.quantity_advice?.approx_value);
      return sum + (Number.isNaN(v) ? 0 : v);
    }, 0);
    capital = summed > 0 ? summed : null;
  }
  const count =
    aws_up.stock_count > 0 ? aws_up.stock_count : (stocks || []).length;
  return { capital_required: capital, stock_count: count };
}

function push_action_step(steps, title, description) {
  const text = String(description || "").trim();
  if (!text) return;
  steps.push({ title, description: text });
}

function ActionSectionFilterTotals({ active_filter, action_wise, stock_count, stocks, action_summary }) {
  const aws = action_wise || {};
  if (active_filter === "cut_loss") {
    const c = aws.cut_loss || {};
    return (
      <div className="portfolio_action_totals portfolio_action_totals--cut_loss">
        <h3 className="portfolio_action_totals__title">Cut loss — portfolio totals</h3>
        <div className="portfolio_action_totals__chips">
          <div className="portfolio_action_totals__chip">
            <span>Loss booked (trim qty)</span>
            <strong className="neg">{fmt_inr(c.net_loss)}</strong>
          </div>
          <div className="portfolio_action_totals__chip">
            <span>Total loss (full positions)</span>
            <strong className="neg">{fmt_inr(c.current_total_loss)}</strong>
          </div>
          <div className="portfolio_action_totals__chip">
            <span>Cash raised</span>
            <strong>{fmt_inr(c.net_proceeds)}</strong>
          </div>
          <div className="portfolio_action_totals__chip">
            <span>Stocks</span>
            <strong>{stock_count}</strong>
          </div>
        </div>
        <p className="portfolio_action_totals__hint">
          Loss booked uses the same immediate trim as Phase 1 in the three-phase plan (staggered
          step 1 when present; otherwise advisor trim).
        </p>
      </div>
    );
  }
  if (active_filter === "accumulate") {
    return null;
  }
  if (active_filter === "hold") {
    return (
      <div className="portfolio_action_totals portfolio_action_totals--hold">
        <h3 className="portfolio_action_totals__title">Hold — portfolio totals</h3>
        <p className="portfolio_action_totals__hint">
          No deployment or sale is scheduled here. Switch to another section for portfolio-wide
          cash and P&amp;L totals.
        </p>
      </div>
    );
  }
  if (active_filter === "profit_booking") {
    const p = aws.profit_booking || {};
    return (
      <div className="portfolio_action_totals portfolio_action_totals--profit_booking">
        <h3 className="portfolio_action_totals__title">Book profit — portfolio totals</h3>
        <div className="portfolio_action_totals__chips">
          <div className="portfolio_action_totals__chip">
            <span>Profit booked</span>
            <strong className="pos">{fmt_inr(p.profit_booked)}</strong>
          </div>
          <div className="portfolio_action_totals__chip">
            <span>Cash from sales</span>
            <strong>{fmt_inr(p.net_proceeds)}</strong>
          </div>
          <div className="portfolio_action_totals__chip">
            <span>Stocks</span>
            <strong>{p.stock_count ?? stock_count}</strong>
          </div>
        </div>
      </div>
    );
  }
  if (active_filter === "exit") {
    const e = aws.exit || {};
    const pnl = e.net_pnl;
    return (
      <div className="portfolio_action_totals portfolio_action_totals--exit">
        <h3 className="portfolio_action_totals__title">Exit — portfolio totals</h3>
        <div className="portfolio_action_totals__chips">
          <div className="portfolio_action_totals__chip">
            <span>Net P&amp;L</span>
            <strong className={pct_class(pnl)}>{pnl != null ? fmt_inr(pnl, true) : "—"}</strong>
          </div>
          <div className="portfolio_action_totals__chip">
            <span>Cash proceeds</span>
            <strong>{fmt_inr(e.net_proceeds)}</strong>
          </div>
          <div className="portfolio_action_totals__chip">
            <span>Stocks</span>
            <strong>{e.stock_count ?? stock_count}</strong>
          </div>
        </div>
      </div>
    );
  }
  if (active_filter === "average_down") {
    const d = aws.average_down || {};
    return (
      <div className="portfolio_action_totals portfolio_action_totals--average_down">
        <h3 className="portfolio_action_totals__title">Average down — portfolio totals</h3>
        <div className="portfolio_action_totals__chips">
          <div className="portfolio_action_totals__chip">
            <span>Capital to buy now</span>
            <strong>{fmt_inr(d.capital_required)}</strong>
          </div>
          <div className="portfolio_action_totals__chip">
            <span>Modeled net loss reduction</span>
            <strong className="pos">{fmt_inr(d.net_loss_saved)}</strong>
          </div>
          <div className="portfolio_action_totals__chip">
            <span>Stocks</span>
            <strong>{d.stock_count ?? stock_count}</strong>
          </div>
        </div>
        {d.stocks_with_modeled_savings_count != null &&
          d.stock_count != null &&
          d.stocks_with_modeled_savings_count < d.stock_count && (
            <p className="portfolio_action_totals__hint">
              Modeled “loss saved” uses phased sell plans where the API included an avg-down plan;{" "}
              {d.stocks_with_modeled_savings_count} of {d.stock_count} stocks.
            </p>
          )}
      </div>
    );
  }
  return null;
}

function cut_loss_prob_class(prob) {
  const p = parseFloat(prob);
  if (Number.isNaN(p)) return "portfolio_cut_prob--muted";
  if (p >= 55) return "portfolio_cut_prob--hi";
  if (p >= 35) return "portfolio_cut_prob--md";
  return "portfolio_cut_prob--lo";
}

function cut_loss_hard_stop_note(plan) {
  const label = String(plan?.hard_stop_label || "").trim();
  if (label) return label;
  return "Exit all remaining immediately if price drops here.";
}

function StaggeredCutLossPlanPanel({ stock, holding }) {
  const plan = stock?.staggered_cut_loss_plan;
  if (!plan || typeof plan !== "object") return null;

  const sn = plan.sell_now || {};
  const fts = plan.future_tranches || [];
  const horizon_days = plan.horizon_days != null ? plan.horizon_days : 180;
  const step_count = 1 + fts.length;

  return (
    <section className="portfolio_cut_loss_plan" aria-label="Staggered cut loss plan">
      <header className="portfolio_cut_loss_plan__head">
        <div>
          <h4 className="portfolio_cut_loss_plan__title">Staggered cut loss</h4>
          <p className="portfolio_cut_loss_plan__lead">
            Trim in stages — lock in part of the loss now, exit more only if price bounces.
          </p>
        </div>
        <span className="portfolio_cut_loss_plan__badge">{step_count} steps</span>
      </header>

      <article className="portfolio_cut_loss_step portfolio_cut_loss_step--now">
        <div className="portfolio_cut_loss_step__left">
          <span className="portfolio_cut_loss_step__num" aria-hidden="true">
            1
          </span>
          <span className="portfolio_cut_loss_step__lbl">Sell now</span>
        </div>
        <div className="portfolio_cut_loss_step__body">
          <p className="portfolio_cut_loss_step__trade">
            Sell <strong>{sn.qty ?? "—"}</strong> @{" "}
            <strong className="portfolio_cut_loss_step__price">{fmt_price_inr(sn.price)}</strong>
          </p>
          <div className="portfolio_cut_loss_step__metrics">
            {sn.loss_booked != null && (
              <div className="portfolio_cut_loss_metric">
                <span className="portfolio_cut_loss_metric__lbl">Loss booked</span>
                <span className="portfolio_cut_loss_metric__val neg">~{fmt_inr(sn.loss_booked)}</span>
              </div>
            )}
            {sn.proceeds != null && (
              <div className="portfolio_cut_loss_metric">
                <span className="portfolio_cut_loss_metric__lbl">Proceeds</span>
                <span className="portfolio_cut_loss_metric__val">~{fmt_inr(sn.proceeds)}</span>
              </div>
            )}
          </div>
        </div>
        <span className="portfolio_cut_loss_step__tag portfolio_cut_prob--spot">@ spot</span>
      </article>

      {fts.length > 0 ? (
        <>
          <p className="portfolio_cut_loss_plan__subhead">Steps 2–3 — If price recovers</p>
          {fts.map((ft, idx) => {
            const tr = ft.tranche != null ? String(ft.tranche) : String(2 + idx);
            const prob = ft.prob_reach_pct;
            const prob_text =
              prob != null && !Number.isNaN(parseFloat(prob))
                ? `${Number(prob).toFixed(1)}% reach · ${horizon_days}d`
                : null;
            return (
              <article key={`cut-tr-${tr}`} className="portfolio_cut_loss_step portfolio_cut_loss_step--future">
                <div className="portfolio_cut_loss_step__left">
                  <span className="portfolio_cut_loss_step__num" aria-hidden="true">
                    {tr}
                  </span>
                  <span className="portfolio_cut_loss_step__lbl">Sell {tr}</span>
                </div>
                <div className="portfolio_cut_loss_step__body">
                  <p className="portfolio_cut_loss_step__trade">
                    Sell <strong>{ft.qty ?? "—"}</strong> @{" "}
                    <strong className="portfolio_cut_loss_step__price">{fmt_price_inr(ft.trigger_price)}</strong>
                  </p>
                  {ft.upside_pct != null && (
                    <p className="portfolio_cut_loss_step__upside">
                      +{Number(ft.upside_pct).toFixed(2)}% vs today
                    </p>
                  )}
                </div>
                <span
                  className={`portfolio_cut_loss_step__tag ${
                    prob_text ? cut_loss_prob_class(prob) : "portfolio_cut_prob--muted"
                  }`}
                >
                  {prob_text || "—"}
                </span>
              </article>
            );
          })}
        </>
      ) : (
        <p className="portfolio_cut_loss_plan__empty">
          No extra recovery tranches in this plan. Step 1 still applies — re-upload after refreshing quotes if needed.
        </p>
      )}

      {plan.hard_stop != null && (
        <div className="portfolio_cut_loss_plan__stop" role="note">
          <span className="portfolio_cut_loss_plan__stop_icon" aria-hidden="true">
            ⚠
          </span>
          <div className="portfolio_cut_loss_plan__stop_text">
            <strong>Hard stop {fmt_price_inr(plan.hard_stop)}</strong>
            <span>{cut_loss_hard_stop_note(plan)}</span>
          </div>
        </div>
      )}
    </section>
  );
}

function AvgDownPlanPanel({ stock, holding, quantity_advice }) {
  const plan = stock?.avg_down_plan;
  if (!plan || typeof plan !== "object") return null;

  const qa = quantity_advice || {};
  const curr_p = parseFloat(holding?.current_price);
  const phases = plan.phases || [];
  const phases_hi = phases.filter((p) => {
    const pr = parseFloat(p.prob_reach_pct);
    return !Number.isNaN(pr) && pr >= 30;
  });
  const phases_show = phases_hi.length ? phases_hi : phases;

  let total_after = plan.total_qty_after != null ? parseFloat(plan.total_qty_after) : NaN;
  if (Number.isNaN(total_after)) {
    const hq = parseFloat(holding?.qty);
    const bq = plan.add_qty != null ? parseFloat(plan.add_qty) : parseFloat(qa.approx_units);
    if (!Number.isNaN(hq)) total_after = hq + (Number.isNaN(bq) ? 0 : bq);
  }

  let sold_so_far = 0;

  return (
    <div className="portfolio_action_plan portfolio_action_plan--avg">
      <h4 className="portfolio_action_plan__title">Average down — step-by-step</h4>
      <p className="portfolio_action_plan__intro">
        First add at the <strong>current market price</strong>. Then exit in phases when price
        reaches each target (~180-day Monte Carlo window; ≥30% reach where shown).
      </p>
      <p className="portfolio_action_plan__subhead">Step 1 — Buy now</p>
      <div className="portfolio_action_plan__metrics">
        {(plan.add_qty != null || qa.approx_units) && (
          <div>
            <span>Buy</span>
            <strong>
              {plan.add_qty ?? qa.approx_units} units @{" "}
              {!Number.isNaN(curr_p) ? (
                <span className="pos">₹{curr_p.toLocaleString("en-IN")}</span>
              ) : (
                "current price"
              )}
            </strong>
          </div>
        )}
        {(plan.capital_required != null || qa.approx_value != null) && (
          <div>
            <span>Total to deploy</span>
            <strong>{fmt_inr(plan.capital_required ?? qa.approx_value)}</strong>
          </div>
        )}
        {plan.new_avg_buy_price != null && (
          <div>
            <span>New avg cost (after buy)</span>
            <strong>₹{Number(plan.new_avg_buy_price).toLocaleString("en-IN")}</strong>
          </div>
        )}
        {plan.original_loss != null && (
          <div>
            <span>Loss before plan</span>
            <strong className="neg">{fmt_inr(plan.original_loss)}</strong>
          </div>
        )}
      </div>
      {phases_show.length > 0 ? (
        <>
          <p className="portfolio_action_plan__subhead">Step 2 — Sell in phases</p>
          <div className="portfolio_lh_phase_list">
            {phases_show.map((p, idx) => {
              const qn = parseFloat(p.qty);
              if (!Number.isNaN(qn)) sold_so_far += qn;
              const remaining =
                !Number.isNaN(total_after) && !Number.isNaN(sold_so_far)
                  ? Math.max(0, Math.round(total_after - sold_so_far))
                  : null;
              const prob = p.prob_reach_pct;
              return (
                <div key={idx} className="portfolio_lh_phase_row">
                  <span className="portfolio_lh_phase_lbl">Sell {idx + 1}</span>
                  <span className="portfolio_lh_phase_body">
                    Sell <strong>{p.qty ?? "—"}</strong> @{" "}
                    <span className="portfolio_lh_price">
                      ₹
                      {p.trigger_price != null
                        ? Number(p.trigger_price).toLocaleString("en-IN")
                        : "—"}
                    </span>
                    {p.upside_pct != null && (
                      <span className="portfolio_lh_muted">
                        {" "}
                        (+{Number(p.upside_pct).toFixed(2)}% vs today)
                      </span>
                    )}
                    {remaining != null && (
                      <span className="portfolio_lh_muted"> · Remaining: {remaining} units</span>
                    )}
                  </span>
                  <span className="portfolio_lh_prob">
                    {prob != null && !Number.isNaN(parseFloat(prob)) ? `${prob}% reach · 180d` : "—"}
                  </span>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <p className="portfolio_action_plan__muted">
          Sell-phase targets will appear once the plan is returned from analysis.
        </p>
      )}
      {plan.hard_stop != null && (
        <p className="portfolio_action_plan__foot">
          Hard stop <strong className="neg">₹{Number(plan.hard_stop).toLocaleString("en-IN")}</strong>
          {plan.worst_case_loss != null && (
            <> · worst-case extra loss ≈ {fmt_inr(plan.worst_case_loss)}</>
          )}
        </p>
      )}
    </div>
  );
}

function SectionEmptyState({ message = "No stock present in this section" }) {
  return (
    <div className="portfolio_section_empty">
      <h4 className="portfolio_section_empty__title">{message}</h4>
    </div>
  );
}

function ActionSectionStockSidebar({
  stocks,
  selected_code,
  on_select,
  section_label,
  active_filter,
}) {
  const [chip_filter, set_chip_filter] = useState("all");
  const [sort_key, set_sort_key] = useState("default");
  const [local_search, set_local_search] = useState("");

  const sidebar_title = action_section_sidebar_title(active_filter, section_label);

  useEffect(() => {
    set_chip_filter("all");
    set_sort_key("default");
    set_local_search("");
  }, [active_filter, section_label]);

  const default_order_index = useMemo(() => {
    const index = new Map();
    (stocks || []).forEach((stock, idx) => {
      if (stock?.code != null) index.set(stock.code, idx);
    });
    return index;
  }, [stocks]);

  const chip_counts = useMemo(() => {
    const counts = {};
    SIDEBAR_CHIP_FILTERS.forEach((chip) => {
      counts[chip.id] = count_stocks_for_sidebar_chip(stocks, chip.id);
    });
    return counts;
  }, [stocks]);

  const display_stocks = useMemo(() => {
    const q = local_search.trim();
    let list = stocks.filter((s) => matches_sidebar_chip_filter(s, chip_filter));
    if (q) list = list.filter((s) => stock_matches_search(s, q));
    return sort_sidebar_stocks(list, sort_key, default_order_index);
  }, [stocks, chip_filter, sort_key, local_search, default_order_index]);

  useEffect(() => {
    if (!display_stocks.length) return;
    const still_visible = display_stocks.some((s) => s.code === selected_code);
    if (!still_visible) on_select(display_stocks[0].code);
  }, [display_stocks, selected_code, on_select]);

  if (!stocks.length) return null;

  return (
    <aside className="portfolio_action_sidebar">
      <div className="portfolio_action_sidebar__card">
      <div className="portfolio_action_sidebar__controls">
        <div className="portfolio_action_sidebar__head">
          <h3 className="portfolio_action_sidebar__title">{sidebar_title}</h3>
          <span className="portfolio_action_sidebar__count">{stocks.length}</span>
        </div>

        <div className="portfolio_action_sidebar__search_wrap">
          <span className="portfolio_action_sidebar__search_icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
              <path d="M20 20L16 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </span>
          <input
            type="search"
            className="portfolio_action_sidebar__search"
            placeholder="Search stocks..."
            value={local_search}
            onChange={(e) => set_local_search(e.target.value)}
            aria-label="Search stocks in list"
          />
        </div>

        <div className="portfolio_action_sidebar__chips" role="group" aria-label="Filter stocks">
          {SIDEBAR_CHIP_FILTERS.map((chip) => {
            const count = chip_counts[chip.id] ?? 0;
            const chip_label = chip.id === "all" ? `All (${count})` : chip.label;
            return (
              <button
                key={chip.id}
                type="button"
                className={`portfolio_action_sidebar__chip${chip_filter === chip.id ? " is_active" : ""}`}
                onClick={() => set_chip_filter(chip.id)}
              >
                {chip_label}
              </button>
            );
          })}
        </div>

        <div className="portfolio_action_sidebar__sort">
          <span className="portfolio_action_sidebar__sort_lbl">Sort by:</span>
          <select
            className="portfolio_action_sidebar__sort_select"
            value={sort_key}
            onChange={(e) => set_sort_key(e.target.value)}
            aria-label="Sort stocks"
          >
            {SIDEBAR_SORT_OPTIONS.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <ul
        key={`${chip_filter}-${sort_key}-${local_search.trim()}`}
        className="portfolio_action_sidebar__list"
        role="tablist"
        aria-label={sidebar_title}
      >
        {display_stocks.length === 0 ? (
          <li className="portfolio_action_sidebar__empty">No stocks match this filter.</li>
        ) : (
          display_stocks.map((stock) => {
            const h = stock.holding || {};
            const is_active = selected_code === stock.code;
            const price_label =
              h.current_price != null
                ? `₹${Number(h.current_price).toLocaleString("en-IN")}`
                : "—";
            const badge = sidebar_action_badge(stock);
            const sector_price = `${stock.industry_group || "—"} · ${price_label}`;
            const item_mod = [
              is_active ? "is_active" : "",
              badge.category ? `is_${badge.category}` : "",
            ]
              .filter(Boolean)
              .join(" ");

            return (
              <li key={stock.code} className="portfolio_action_sidebar__row">
                <button
                  type="button"
                  role="tab"
                  aria-selected={is_active}
                  className={`portfolio_action_sidebar__item${item_mod ? ` ${item_mod}` : ""}`}
                  onClick={() => on_select(stock.code)}
                >
                  <span
                    className={`portfolio_action_sidebar__avatar ${sidebar_avatar_tone(stock)}`}
                    aria-hidden="true"
                  >
                    {stock_initials(stock)}
                  </span>
                  <span className="portfolio_action_sidebar__center">
                    <strong className="portfolio_action_sidebar__name">
                      {stock.name || stock.code}
                    </strong>
                    <span className="portfolio_action_sidebar__sector_line">{sector_price}</span>
                  </span>
                  <span className="portfolio_action_sidebar__rail">
                    <span className={`portfolio_action_sidebar__chg ${pct_class(h.return_pct)}`}>
                      {fmt_pct(h.return_pct)}
                    </span>
                    <span className={badge.class_name}>{badge.label}</span>
                  </span>
                </button>
              </li>
            );
          })
        )}
      </ul>
      </div>
    </aside>
  );
}

function ActionSectionPage({
  stocks,
  selected_stock,
  selected_code,
  on_select_stock,
  section_label,
  active_tab,
  on_tab_change,
  data,
  active_filter,
}) {
  const show_three_phase =
    active_filter === "cut_loss" || active_filter === "average_down";
  const portfolio_stocks = data?.stocks || [];

  const section_mod = active_filter ? ` portfolio_action_section--${active_filter}` : "";

  const action_wise = data?.action_wise_summary || {};

  return (
    <div className={`portfolio_action_section${section_mod}`}>
      <ActionSectionFilterTotals
        active_filter={active_filter}
        action_wise={action_wise}
        stock_count={stocks.length}
        stocks={stocks}
        action_summary={data?.action_summary}
      />
      <div className="portfolio_action_section__layout">
        <ActionSectionStockSidebar
          stocks={stocks}
          selected_code={selected_code}
          on_select={on_select_stock}
          section_label={section_label}
          active_filter={active_filter}
        />
        <div className="portfolio_action_section__detail_panel">
          <div className="portfolio_action_section__detail_scroll">
            {stocks.length === 0 ? (
              <SectionEmptyState />
            ) : selected_stock ? (
              <div className="portfolio_action_section__stock_card">
                <StockDetailPanel
                  stock={selected_stock}
                  active_tab={active_tab}
                  on_tab_change={on_tab_change}
                  portfolio_stocks={portfolio_stocks}
                  section_filter={active_filter}
                  three_phase_portfolio={
                    show_three_phase ? data?.three_phase_portfolio : null
                  }
                />
              </div>
            ) : (
              <div className="portfolio_action_section__placeholder">
                Select a stock from the list to view its execution plan.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function PortfolioHoldingsPage({ stocks, selected_stock, on_select_stock, on_close_detail, detail_ref }) {
  const { nse_code, bse_code } = selected_stock
    ? get_stock_exchange_codes(selected_stock)
    : { nse_code: null, bse_code: null };

  return (
    <div className={`portfolio_holdings_page${selected_stock ? " is_detail" : ""}`}>
      <div className="portfolio_holdings_page__head">
        <div className="portfolio_holdings_page__titles">
          {selected_stock ? (
            <>
              <h2 className="portfolio_holdings_page__title">
                {selected_stock.name || selected_stock.code}
              </h2>
              <p className="portfolio_holdings_page__subtitle">
                {nse_code ? `NSE ${nse_code}` : selected_stock.code}
                {bse_code ? ` · BSE ${bse_code}` : ""}
                {selected_stock.industry_group ? ` · ${selected_stock.industry_group}` : ""}
              </p>
            </>
          ) : (
            <>
              <h2 className="portfolio_holdings_page__title"><span style={{color: '#F15623'}}>Portfolio</span> holdings</h2>
              <p className="portfolio_holdings_page__subtitle">
                {stocks.length} stock{stocks.length === 1 ? "" : "s"} in your uploaded portfolio
              </p>
            </>
          )}
        </div>
        {selected_stock && (
          <button type="button" className="portfolio_holdings_page__back" onClick={on_close_detail}>
            ← Back to list
          </button>
        )}
      </div>

      {!selected_stock && (
        <PortfolioHoldingsTable stocks={stocks} on_select_stock={on_select_stock} />
      )}

      {selected_stock && (
        <div className="portfolio_holdings_page__detail" ref={detail_ref}>
          <StockDetailPanel
            stock={selected_stock}
            portfolio_stocks={stocks}
          />
        </div>
      )}
    </div>
  );
}

function StockDetailPanel({
  stock,
  active_tab,
  on_tab_change,
  portfolio_stocks = [],
  section_filter = null,
  three_phase_portfolio = null,
}) {
  const h = stock.holding || {};
  const scores = stock.scores || {};
  const { nse_code, bse_code } = get_stock_exchange_codes(stock);
  const show_tabs = typeof on_tab_change === "function";

  if (!show_tabs) {
    return (
      <div className="portfolio_stock_detail">
        <div className="portfolio_stock_detail__summary">
          <div className="portfolio_stock_detail__summary_top">
            <div className="portfolio_stock_detail__tags">
              <span className={action_badge_class(stock.action)}>{action_badge_label(stock)}</span>
              {stock.isin && <span className="portfolio_stock_detail__tag">ISIN {stock.isin}</span>}
            </div>
            <div className="portfolio_stock_detail__score_inline" title="SIHO combined score">
              <span className="portfolio_stock_detail__score_cap">SIHO</span>
              <strong>
                {scores.combined != null ? Number(scores.combined).toFixed(2) : "—"}
              </strong>
              <span className="portfolio_stock_detail__score_of">/ 5</span>
            </div>
          </div>
          <div className="portfolio_stock_detail__metrics">
            <div className="portfolio_stock_detail__metric">
              <span>Price</span>
              <strong className="pos">
                {h.current_price != null
                  ? `₹${Number(h.current_price).toLocaleString("en-IN")}`
                  : "—"}
              </strong>
            </div>
            <div className="portfolio_stock_detail__metric">
              <span>Qty</span>
              <strong>{h.qty != null ? fmt_num(h.qty) : "—"}</strong>
            </div>
            <div className="portfolio_stock_detail__metric">
              <span>Invested</span>
              <strong>{fmt_inr(h.total_investment)}</strong>
            </div>
            <div className="portfolio_stock_detail__metric">
              <span>Market value</span>
              <strong>{fmt_inr(h.current_value)}</strong>
            </div>
            <div className="portfolio_stock_detail__metric">
              <span>Return</span>
              <strong className={pct_class(h.return_pct)}>{fmt_pct(h.return_pct)}</strong>
            </div>
          </div>
        </div>

        <div className="portfolio_stock_detail__body">
          <div className="portfolio_detail_card portfolio_chart_panel portfolio_chart_panel--tight">
            <div className="portfolio_chart_panel__head">
              <h4 className="portfolio_detail_card__title">Returns vs Nifty</h4>
              <p className="portfolio_chart_panel__sub">Stock vs index</p>
            </div>
            <PeriodVsNiftyChart period_vs_nifty={h.period_vs_nifty} compact />
          </div>

          <div className="portfolio_stock_detail__insights">
            <SihoScoresCard scores={scores} layout="row" />
            <PortfolioImpactCard portfolio_impact={stock.portfolio_impact} />
          </div>

          <PortfolioImpactSummary summary={stock.portfolio_impact?.impact_summary} />

          {stock.summary && (
            <div className="portfolio_detail_card">
              <h4 className="portfolio_detail_card__title">Analysis</h4>
              <p className="portfolio_detail_card__text">{stock.summary}</p>
            </div>
          )}
          {stock.expert_view && (
            <div className="portfolio_detail_card">
              <h4 className="portfolio_detail_card__title">Expert view</h4>
              <p className="portfolio_detail_card__text">{stock.expert_view}</p>
            </div>
          )}

          <StockDeepDiveSections stock={stock} portfolio_stocks={portfolio_stocks} />
        </div>
      </div>
    );
  }

  const section_class = section_filter ? ` portfolio_action_detail--${section_filter}` : "";
  const is_action_section = !!section_filter;
  const avg_buy_label =
    h.avg_buy_price != null
      ? `₹${Number(h.avg_buy_price).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "—";

  return (
    <>
      <div className={`portfolio_dashboard__detail_head${section_class}`}>
        <div className="portfolio_detail_head__top">
          <div className="portfolio_detail_head__identity">
            <div className="portfolio_detail_head__title_row">
              <div className="portfolio_detail_head__name_block">
                <span className="portfolio_detail_head__name_icon" aria-hidden="true">
                  📈
                </span>
                <h2 className="portfolio_dashboard__detail_title">
                  {stock.name || stock.code}
                  {is_action_section && nse_code && (
                    <span className="portfolio_detail_head__nse_code">NSE {nse_code}</span>
                  )}
                </h2>
              </div>
              {is_action_section && (
                <span className={`portfolio_detail_head__return ${pct_class(h.return_pct)}`}>
                  {fmt_pct(h.return_pct)}
                </span>
              )}
            </div>
            {!is_action_section && (
              <div className="portfolio_detail_head__meta">
                <div className="portfolio_detail_head__tags">
                  <span className="portfolio_detail_head__tag">{stock.code}</span>
                  {nse_code && (
                    <span className="portfolio_detail_head__tag portfolio_detail_head__tag--exchange">
                      NSE {nse_code}
                    </span>
                  )}
                  {bse_code && (
                    <span className="portfolio_detail_head__tag portfolio_detail_head__tag--exchange">
                      BSE {bse_code}
                    </span>
                  )}
                  <span className={action_badge_class(stock.action)}>{action_badge_label(stock)}</span>
                </div>
                <div className="portfolio_detail_head__meta_line">
                  {stock.industry_group && (
                    <span className="portfolio_detail_head__sector">{stock.industry_group}</span>
                  )}
                  {stock.industry_group && stock.isin && (
                    <span className="portfolio_detail_head__dot" aria-hidden="true">
                      ·
                    </span>
                  )}
                  {stock.isin && (
                    <span className="portfolio_detail_head__isin">ISIN {stock.isin}</span>
                  )}
                </div>
              </div>
            )}
          </div>
          <div
            className={
              is_action_section
                ? "portfolio_detail_head__score_simple"
                : "portfolio_dashboard__score_box portfolio_dashboard__score_box--detail"
            }
          >
            <span className="portfolio_dashboard__score_lbl">
              <span className="portfolio_detail_head__score_icon" aria-hidden="true">
                ⭐
              </span>
              SIHO Score
            </span>
            <div className="portfolio_dashboard__score_detail_val">
              <span className="portfolio_dashboard__score_val">
                {scores.combined != null ? Number(scores.combined).toFixed(2) : "—"}
              </span>
              <span className="portfolio_dashboard__score_of">/ 5</span>
            </div>
            {scores.combined != null && (
              <div className="portfolio_dashboard__score_meter" aria-hidden="true">
                <span
                  style={{
                    width: `${Math.min(100, Math.max(0, (Number(scores.combined) / 5) * 100))}%`,
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="portfolio_dashboard__detail_kpis">
          <span>
            <span className="portfolio_detail_kpi__icon" aria-hidden="true">
              💰
            </span>
            Current price
            <strong className="pos">
              {h.current_price != null
                ? `₹${Number(h.current_price).toLocaleString("en-IN")}`
                : "—"}
            </strong>
          </span>
          <span>
            <span className="portfolio_detail_kpi__icon" aria-hidden="true">
              📦
            </span>
            Quantity
            <strong>{h.qty != null ? fmt_num(h.qty) : "—"}</strong>
          </span>
          <span>
            <span className="portfolio_detail_kpi__icon" aria-hidden="true">
              🏦
            </span>
            Invested
            <strong>{fmt_inr(h.total_investment)}</strong>
          </span>
          <span>
            <span className="portfolio_detail_kpi__icon" aria-hidden="true">
              📊
            </span>
            Market value
            <strong>{fmt_inr(h.current_value)}</strong>
          </span>
          {is_action_section ? (
            <span>
              <span className="portfolio_detail_kpi__icon" aria-hidden="true">
                🎯
              </span>
              Avg buy price
              <strong>{avg_buy_label}</strong>
            </span>
          ) : (
            <span>
              <span className="portfolio_detail_kpi__icon" aria-hidden="true">
                📈
              </span>
              Return
              <strong className={pct_class(h.return_pct)}>{fmt_pct(h.return_pct)}</strong>
            </span>
          )}
        </div>
      </div>

      {show_tabs && (
        <div
          className={`portfolio_detail_tabs_bar${is_action_section ? " is_action_section" : ""}`}
        >
          {is_action_section && (
            <p className="portfolio_detail_tabs_bar__label">Choose how to view this stock</p>
          )}
          <div
            className="portfolio_dashboard__tabs portfolio_detail_tabs_bar__tabs"
            role="tablist"
            aria-label="Stock detail views"
          >
            <button
              type="button"
              role="tab"
              aria-selected={active_tab === "execution"}
              className={`portfolio_dashboard__tab${active_tab === "execution" ? " active" : ""}`}
              onClick={() => on_tab_change("execution")}
            >
              <span className="portfolio_dashboard__tab_icon" aria-hidden="true">
                📋
              </span>
              {is_action_section ? "Execution step" : "Execution plan"}
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={active_tab === "expert"}
              className={`portfolio_dashboard__tab${active_tab === "expert" ? " active" : ""}`}
              onClick={() => on_tab_change("expert")}
            >
              <span className="portfolio_dashboard__tab_icon" aria-hidden="true">
                🤖
              </span>
              AI expert view
            </button>
          </div>
        </div>
      )}

      <div className="portfolio_dashboard__detail_body">
        {active_tab === "expert" ? (
          <div className="portfolio_expert_view">
            <ExpertNarrativeSection title="AI expert view" text={stock.expert_view} icon="🤖" />
            <ExpertNarrativeSection title="Analysis summary" text={stock.summary} icon="📄" />
            <SihoScoresPanel scores={scores} icon="⭐" />
            <StockDeepDiveSections stock={stock} portfolio_stocks={portfolio_stocks} />
          </div>
        ) : (
          <div className="portfolio_execution_tab">
            {three_phase_portfolio && (
              <ThreePhasePortfolioPanel
                three_phase_portfolio={three_phase_portfolio}
                className="portfolio_tph--execution_tab"
              />
            )}
            {is_action_section ? (
              <StockExecutionStepPanel
                stock={stock}
                holding={h}
                quantity_advice={stock.quantity_advice}
              />
            ) : (
              <StockActionExecutionPanel
                stock={stock}
                holding={h}
                quantity_advice={stock.quantity_advice}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}

function ThreePhaseFooter({ data }) {
  const tpp = data?.three_phase_portfolio;
  if (!tpp) return null;
  const ft = tpp.footer || {};
  const p1 = tpp.phase_1 || {};
  const p2 = tpp.phase_2 || {};
  const p3 = tpp.phase_3 || {};
  return (
    <div className="portfolio_dashboard__phase_foot">
      <div>
        <span>Cumulative loss</span>
        <strong className="neg">{fmt_inr(ft.cumulative_loss_booked_all_phases)}</strong>
      </div>
      <div>
        <span>Residual unrealised loss</span>
        <strong className="neg">
          {fmt_inr(ft.estimated_residual_unrealized_loss)}
        </strong>
      </div>
      <div>
        <span>Phase 1 / 2 / 3 loss</span>
        <strong>
          {fmt_inr(p1.loss_booked)} / {fmt_inr(p2.loss_booked)} /{" "}
          {fmt_inr(p3.loss_booked)}
        </strong>
      </div>
    </div>
  );
}

function GlobalStockSearch({ stocks, search_query, on_search_change, on_select_stock }) {
  const [is_open, set_is_open] = useState(false);
  const wrap_ref = useRef(null);

  const search_results = useMemo(() => {
    const q = search_query.trim();
    if (!q) return [];
    return stocks.filter((s) => stock_matches_search(s, q)).slice(0, 8);
  }, [stocks, search_query]);

  useEffect(() => {
    const handle_click_outside = (event) => {
      if (wrap_ref.current && !wrap_ref.current.contains(event.target)) {
        set_is_open(false);
      }
    };
    document.addEventListener("mousedown", handle_click_outside);
    return () => document.removeEventListener("mousedown", handle_click_outside);
  }, []);

  const show_dropdown = is_open && search_query.trim().length > 0;

  return (
    <div className="portfolio_dashboard__search_wrap" ref={wrap_ref}>
      <svg
        className="portfolio_dashboard__search_icon"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.75" />
        <path
          d="M16.5 16.5L21 21"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
        />
      </svg>
      <input
        type="search"
        className="portfolio_dashboard__search"
        placeholder="Search by name, NSE or BSE code…"
        value={search_query}
        onChange={(e) => {
          on_search_change(e.target.value);
          set_is_open(true);
        }}
        onFocus={() => set_is_open(true)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            set_is_open(false);
          }
          if (e.key === "Enter" && search_results[0]) {
            on_select_stock(search_results[0]);
            set_is_open(false);
          }
        }}
        aria-label="Search stocks by name, NSE code, or BSE code"
        aria-expanded={show_dropdown}
        aria-controls="global-stock-search-results"
        autoComplete="off"
      />
      {show_dropdown && (
        <div
          id="global-stock-search-results"
          className="portfolio_dashboard__search_dropdown"
          role="listbox"
        >
          {search_results.length === 0 ? (
            <div className="portfolio_dashboard__search_empty">No matching stocks</div>
          ) : (
            search_results.map((stock) => {
              const { nse_code, bse_code } = get_stock_exchange_codes(stock);
              return (
                <button
                  type="button"
                  key={stock.code}
                  className="portfolio_dashboard__search_result"
                  role="option"
                  onClick={() => {
                    on_select_stock(stock);
                    set_is_open(false);
                  }}
                >
                  <span className="portfolio_dashboard__search_result_main">
                    <span className="portfolio_dashboard__search_result_name">
                      {stock.name || stock.code}
                    </span>
                    <span className="portfolio_dashboard__search_result_meta">
                      <span className="portfolio_dashboard__search_result_action">
                        {action_badge_label(stock)}
                      </span>
                      <span className="portfolio_dashboard__search_result_section">
                        → {nav_label_for_stock(stock)}
                      </span>
                    </span>
                  </span>
                  <span className="portfolio_dashboard__search_result_codes">
                    {nse_code && <span>NSE {nse_code}</span>}
                    {bse_code && <span>BSE {bse_code}</span>}
                    {!nse_code && !bse_code && stock.code && <span>{stock.code}</span>}
                  </span>
                </button>
              );
            })
          )}
        </div>
      )}
    </div>
  );
}

export default function PortfolioDashboard({ data, on_new_analysis, on_logout }) {
  const handle_logout = on_logout || on_new_analysis;
  const stocks = data?.stocks || [];
  const port = data?.portfolio || {};

  const [active_nav_id, set_active_nav_id] = useState("dashboard");
  const [selected_code, set_selected_code] = useState(null);
  const [active_tab, set_active_tab] = useState("execution");
  const [search_query, set_search_query] = useState("");
  const portfolio_detail_ref = useRef(null);

  const filter_counts = useMemo(() => count_by_filter(stocks), [stocks]);

  const page_config = useMemo(
    () => get_nav_page_config(active_nav_id),
    [active_nav_id]
  );
  const { page_mode, show_kpis } = page_config;

  const active_filter = page_config.filter_id || "all";

  const visible_stocks = useMemo(
    () => filter_stocks(stocks, active_filter),
    [stocks, active_filter]
  );

  const search_filtered_stocks = useMemo(() => {
    const q = search_query.trim();
    const pool = page_mode === "stock" ? visible_stocks : stocks;
    if (!q) return pool;
    return pool.filter((s) => stock_matches_search(s, q));
  }, [visible_stocks, stocks, search_query, page_mode]);

  const is_portfolio_holdings_page = page_mode === "stock" && active_filter === "all";
  const is_action_section_page =
    page_mode === "stock" && active_filter && active_filter !== "all";

  const action_section_stocks = useMemo(() => {
    if (!is_action_section_page) return search_filtered_stocks;
    if (!selected_code) return search_filtered_stocks;
    const selected = stocks.find((s) => s.code === selected_code);
    if (!selected || search_filtered_stocks.some((s) => s.code === selected_code)) {
      return search_filtered_stocks;
    }
    if (stock_visible_in_filter(selected, active_filter)) {
      return [selected, ...search_filtered_stocks];
    }
    return search_filtered_stocks;
  }, [is_action_section_page, search_filtered_stocks, selected_code, stocks, active_filter]);

  const selected_stock = useMemo(() => {
    if (!selected_code) return null;
    return stocks.find((s) => s.code === selected_code) || null;
  }, [stocks, selected_code]);

  useEffect(() => {
    if (page_mode !== "stock") return;

    if (is_portfolio_holdings_page) {
      if (
        selected_code &&
        !search_filtered_stocks.some((s) => s.code === selected_code)
      ) {
        set_selected_code(null);
      }
      return;
    }

    if (!selected_code) {
      if (search_filtered_stocks.length) set_selected_code(search_filtered_stocks[0].code);
      return;
    }
    const selected = stocks.find((s) => s.code === selected_code);
    if (!selected) {
      set_selected_code(search_filtered_stocks[0]?.code ?? null);
      return;
    }
    const in_list = search_filtered_stocks.some((s) => s.code === selected_code);
    const in_section = stock_visible_in_filter(selected, active_filter);
    if (in_list || in_section) return;
    if (search_filtered_stocks.length) set_selected_code(search_filtered_stocks[0].code);
    else set_selected_code(null);
  }, [
    search_filtered_stocks,
    selected_code,
    stocks,
    active_filter,
    page_mode,
    is_portfolio_holdings_page,
  ]);

  useEffect(() => {
    if (!is_portfolio_holdings_page || !selected_code) return;
    portfolio_detail_ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [selected_code, is_portfolio_holdings_page]);

  const return_abs =
    port.total_invested != null && port.current_value != null
      ? port.current_value - port.total_invested
      : null;

  const plan_loss = plan_loss_amount(data);

  const handle_search_select = (stock) => {
    if (!stock?.code) return;
    const nav_id = nav_id_for_stock(stock);
    const nav_item = SIDEBAR_NAV.find((n) => n.id === nav_id);
    set_search_query("");
    set_active_nav_id(nav_id);
    set_selected_code(stock.code);
    if (nav_item?.nav_type === "filter" && nav_item.filter_id && nav_item.filter_id !== "all") {
      set_active_tab("expert");
    } else {
      set_active_tab("expert");
    }
  };

  const handle_nav_click = (item) => {
    set_active_nav_id(item.id);
    set_search_query("");
    if (item.id === "dashboard") {
      set_selected_code(null);
      set_active_tab("expert");
    } else if (item.nav_type === "filter") {
      if (item.filter_id && item.filter_id !== "all") {
        set_active_tab("execution");
      } else {
        set_active_tab("expert");
      }
      if (item.filter_id === "all") {
        set_selected_code(null);
      }
    } else if (item.tool_action === "execution_plan") {
      set_selected_code(null);
    } else if (item.tool_action === "reports") {
      set_selected_code(null);
    }
  };

  let last_section = "";
  const nav_items = SIDEBAR_NAV.map((item) => {
    const show_section = item.section !== last_section;
    last_section = item.section;
    const count = get_nav_item_count(item, filter_counts);
    return { ...item, show_section, count };
  });

  const handle_download_report = () => {
    window.print();
  };

  const render_main_content = () => {
    if (page_mode === "dashboard") {
      return (
        <PortfolioOverview
          data={data}
          port={port}
          filter_counts={filter_counts}
          return_abs={return_abs}
        />
      );
    }
    if (page_mode === "execution") {
      return <ExecutionPlanPage data={data} />;
    }
    if (page_mode === "reports") {
      return (
        <ReportsPage
          data={data}
          on_download={handle_download_report}
          port={port}
          filter_counts={filter_counts}
        />
      );
    }
    if (is_portfolio_holdings_page) {
      return (
        <PortfolioHoldingsPage
          stocks={search_filtered_stocks}
          selected_stock={selected_stock}
          on_select_stock={set_selected_code}
          on_close_detail={() => set_selected_code(null)}
          detail_ref={portfolio_detail_ref}
        />
      );
    }

    if (is_action_section_page) {
      return (
        <ActionSectionPage
          stocks={action_section_stocks}
          selected_stock={selected_stock}
          selected_code={selected_code}
          on_select_stock={set_selected_code}
          section_label={page_config.title}
          active_tab={active_tab}
          on_tab_change={set_active_tab}
          data={data}
          active_filter={active_filter}
        />
      );
    }

    if (!selected_stock) {
      return <SectionEmptyState />;
    }
    return (
      <StockDetailPanel
        stock={selected_stock}
        active_tab={active_tab}
        on_tab_change={set_active_tab}
      />
    );
  };

  return (
    <div
      className={`portfolio_dashboard app_page${
        page_mode === "dashboard" ? " is_dashboard_page" : ""
      }`}
    >
      <PortfolioPrintReport data={data} filter_counts={filter_counts} />

      <aside className="portfolio_dashboard__sidebar sidebar_premium no_print">
        <div className="sidebar_premium__brand">
          <SidebarBrand />
        </div>

        <nav className="sidebar_premium__nav">
          {nav_items.map((item) => {
            const is_active = active_nav_id === item.id;
            const show_badge = item.show_badge || item.show_count;
            const badge_class = [
              "sidebar_premium__badge",
              is_active ? "is_active" : "",
              !is_active && item.badge_variant === "danger" ? "is_danger" : "",
              !is_active && item.badge_variant === "success" ? "is_success" : "",
              !is_active && item.badge_variant === "muted" ? "is_muted" : "",
              !is_active && item.show_count ? "is_count" : "",
            ]
              .filter(Boolean)
              .join(" ");

            return (
              <div key={item.id} className="sidebar_premium__nav_group">
                {item.show_section && (
                  <div className="sidebar_premium__section">{item.section}</div>
                )}
                <button
                  type="button"
                  className={`sidebar_premium__item${is_active ? " is_active" : ""}`}
                  onClick={() => handle_nav_click(item)}
                >
                  <span className="sidebar_premium__item_left">
                    <SidebarIcon name={item.icon} />
                    <span className="sidebar_premium__label">{item.label}</span>
                  </span>
                  {show_badge && <span className={badge_class}>{item.count}</span>}
                </button>
              </div>
            );
          })}
        </nav>

        <div className="sidebar_premium__footer">
          <button
            type="button"
            className="sidebar_premium__logout"
            onClick={handle_logout}
          >
            <span className="sidebar_premium__item_left">
              <SidebarIcon name="logout" />
              <span className="sidebar_premium__label">Logout</span>
            </span>
          </button>
        </div>
      </aside>

      <main
        className={`portfolio_dashboard__main no_print${
          page_mode === "dashboard" ? " is_dashboard_page" : ""
        }`}
      >
        <header
          className={`portfolio_dashboard__header_fixed no_print${
            page_mode === "dashboard" ? " is_dashboard_header" : ""
          }`}
        >
          <div
            className={`portfolio_dashboard__topbar${
              page_mode === "dashboard" ? " is_dashboard_topbar" : ""
            }`}
          >
            {page_mode !== "dashboard" && (
              <h1
                className={`portfolio_dashboard__title${
                  page_mode === "dashboard" ? " portfolio_dashboard__title--theme" : ""
                }`}
              >
                {page_config.title}
              </h1>
            )}
            <GlobalStockSearch
              stocks={stocks}
              search_query={search_query}
              on_search_change={set_search_query}
              on_select_stock={handle_search_select}
            />
            <div className="portfolio_dashboard__actions">
              <button
                type="button"
                className="portfolio_dashboard__btn portfolio_dashboard__btn_secondary"
                onClick={on_new_analysis}
              >
                + New Analysis
              </button>
              <button
                type="button"
                className="portfolio_dashboard__btn portfolio_dashboard__btn_primary"
                onClick={handle_download_report}
              >
                Download Report
              </button>
            </div>
          </div>
        </header>

        <div
          className={`portfolio_dashboard__scroll${
            is_portfolio_holdings_page ? " portfolio_dashboard__scroll--holdings" : ""
          }${is_action_section_page ? " portfolio_dashboard__scroll--action" : ""}`}
        >
        {show_kpis && (
          <div className="portfolio_dashboard__kpis portfolio_dashboard__kpis--top">
            <div className="portfolio_dashboard__kpi theme">
              <div className="portfolio_dashboard__kpi_lbl">Invested</div>
              <div className="portfolio_dashboard__kpi_val">{fmt_inr(port.total_invested)}</div>
              <div className="portfolio_dashboard__kpi_sub">
                {port.holding_period ? `${port.holding_period} avg hold` : "Total capital deployed"}
              </div>
            </div>
            <div className="portfolio_dashboard__kpi green">
              <div className="portfolio_dashboard__kpi_lbl">Market value</div>
              <div className="portfolio_dashboard__kpi_val">{fmt_inr(port.current_value)}</div>
              <div className="portfolio_dashboard__kpi_sub">Current portfolio value</div>
            </div>
            <div className="portfolio_dashboard__kpi emerald">
              <div className="portfolio_dashboard__kpi_lbl">Total return</div>
              <div className={`portfolio_dashboard__kpi_val ${pct_class(port.return_pct)}`}>
                {fmt_pct(port.return_pct)}
              </div>
              <div className={`portfolio_dashboard__kpi_sub ${pct_class(return_abs)}`}>
                {return_abs != null ? fmt_inr(return_abs, true) : "—"}
              </div>
            </div>
            <div className="portfolio_dashboard__kpi purple">
              <div className="portfolio_dashboard__kpi_lbl">Alpha</div>
              <div className={`portfolio_dashboard__kpi_val ${pct_class(port.alpha_pct)}`}>
                {fmt_pct(port.alpha_pct)}
              </div>
              <div className="portfolio_dashboard__kpi_sub">vs Nifty since buy</div>
            </div>
          </div>
        )}

        <div className="portfolio_dashboard__split">
          <section
            className={`portfolio_dashboard__detail${
              page_mode === "dashboard" ? " portfolio_dashboard__detail--overview" : ""
            }`}
          >
            {render_main_content()}
          </section>
        </div>
        </div>
      </main>
    </div>
  );
}
